import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: any; output: any; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: any; output: any; }
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: any; output: any; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: any; output: any; }
  /** The `StaticUrlType` scalar type represents a string url. */
  JSONStringWithoutAscii: { input: any; output: any; }
  /**
   * A custom scalar type for representing monetary values as decimals.
   *
   * This class is a subclass of graphene.Decimal used within GraphQL schemas for
   * defining monetary value types. It ensures all monetary values are serialized
   * to a standardized string format with up to two decimal places. For whole
   * numbers, the decimal part is omitted in the serialized output.
   */
  MoneyType: { input: any; output: any; }
  /** The `StaticUrlType` scalar type represents a string url. */
  StaticUrlType: { input: any; output: any; }
};

/**
 * This is the implementation of the way to Activate seller products.
 *
 * ### error_codes(field '\__all\__'):
 *
 * * __user_already_start_activation_deactivation__ - user can't start new
 *     deactivation before the previous finished
 *
 * * __base_user_activate_more_than_soft_limit__ - base user can have <=50
 *     active products
 *
 * * __pro_user_choose_free_products__ - pro user firstly must select free products
 */
export type ActivateProducts = {
  __typename?: 'ActivateProducts';
  /** DeactivateProducts errors */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

/** The mutation make dialog important for current user. */
export type AddDialogImportant = {
  __typename?: 'AddDialogImportant';
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * This is the implementation of the way to bulk add the products to the
 * user's favorites.
 *
 * Method add only favourites which are not active.
 */
export type AddFavourites = {
  __typename?: 'AddFavourites';
  isSuccess: Scalars['Boolean']['output'];
};

/**
 * NEED_VERIFICATION - Base user reach products limit
 * CPA_ONLY - Pro user can add only CPA products
 * BAD_CONDITIONS - Pro user bad CPA conditions(balance, conversion)
 * LIMIT_IS_OK - Base/Pro user can add free products
 */
export enum AddProductStatusEnum {
  BadConditions = 'BAD_CONDITIONS',
  CpaOnly = 'CPA_ONLY',
  LimitIsOk = 'LIMIT_IS_OK',
  NeedVerification = 'NEED_VERIFICATION'
}

/**
 * This is the implementation of adding promo for the product
 *
 * **Before adding a product, make sure that promotion is created**
 *
 * Error codes:
 *     - promo_action_not_created - Promo action is not created
 *     - already_adding_removing - task for adding product to promo
 *       action already created
 *     - one_of_error - invalid params for mutation(required on of includeIds,
 *       excludeIds, allProducts)
 *     - params_both_error - invalid params, too many params, only 1 required
 */
export type AddPromoMutation = {
  __typename?: 'AddPromoMutation';
  /** Promote products error */
  errors?: Maybe<Array<GraphResponseError>>;
};

/**
 * This is the implementation of the way to add user into follower list for
 * the current user.
 */
export type AddToFollower = {
  __typename?: 'AddToFollower';
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

/**
 * The object that representation information about one advantage of some
 * promotion.
 */
export type Advantage = {
  __typename?: 'Advantage';
  /** The descriptions about current advantage. */
  description: Scalars['String']['output'];
  /** The url to icon for current advantage. */
  icon?: Maybe<Scalars['String']['output']>;
};

export type AdvantageType = {
  __typename?: 'AdvantageType';
  icon: Scalars['StaticUrlType']['output'];
  /** Bold text wrapped by html tag <b> */
  title: Scalars['String']['output'];
};

/** Mutation for associating Firebase token with user. */
export type AssociateDevice = {
  __typename?: 'AssociateDevice';
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum AuthServices {
  Apple = 'APPLE',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE'
}

/**
 * The object for representation params of form that using fo refill user
 * balance.
 */
export type BalancePayment = {
  __typename?: 'BalancePayment';
  /** The key/value object with params for the payment form. */
  params?: Maybe<WfpParams>;
  /** The url for payment system. */
  url?: Maybe<Scalars['String']['output']>;
};


/**
 * The object for representation params of form that using fo refill user
 * balance.
 */
export type BalancePaymentParamsArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
};

export type BaseLinkedCatalog = {
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

/** The mutation add dialog to black list by current user. */
export type BlockDialogMutation = {
  __typename?: 'BlockDialogMutation';
  /** Block dialogs errors. */
  errors?: Maybe<Array<GraphResponseError>>;
  /** The representation of dialog. */
  thread?: Maybe<Thread>;
};

/** An enumeration. */
export enum BlockStatus {
  BlockedByParticipant = 'BLOCKED_BY_PARTICIPANT',
  BlockedByViewer = 'BLOCKED_BY_VIEWER',
  NotBlocked = 'NOT_BLOCKED'
}

export type BonusbackInfo = {
  __typename?: 'BonusbackInfo';
  amountText: Scalars['String']['output'];
  infoText: Scalars['String']['output'];
  popUp?: Maybe<Array<Maybe<PopUpItem>>>;
};

/** Brand type. */
export type Brand = {
  __typename?: 'Brand';
  /** brand id */
  id: Scalars['Int']['output'];
  image?: Maybe<Scalars['String']['output']>;
  /** If brand is indexed, then it has dedicated indexed catalog page for bots */
  isIndexed: Scalars['Boolean']['output'];
  /** return true if brand is Ukrainian */
  isUkrainian?: Maybe<Scalars['Boolean']['output']>;
  /** brand name */
  name: Scalars['String']['output'];
  /** brand slug */
  slug: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};


/** Brand type. */
export type BrandIsIndexedArgs = {
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The object for representation information about CPA Promotion
 * which owner can to use for current product.
 */
export type CpaPromotion = {
  __typename?: 'CPAPromotion';
  /** The list of advantages of current promotion. */
  advantages: Array<Advantage>;
  /** URL to refill balance */
  balanceUrl: Scalars['String']['output'];
  /** It's `True` if a product can be promoted by the current promotion. */
  canBePromoted: Scalars['Boolean']['output'];
  /** Callback URL after CPA promotion */
  cpaCallbackUrl: Scalars['String']['output'];
  /** The short description of the current promotion. */
  description: Scalars['String']['output'];
  /** The url to icon for the current promotion. */
  icon: Scalars['String']['output'];
  /** User required balance to promote something in CPA */
  minBalanceValue: Scalars['Int']['output'];
  /** name of the promotion */
  promotionName: Scalars['String']['output'];
  /** The reason why product can't be promoted by current promotion. */
  reason?: Maybe<Scalars['String']['output']>;
  /** The code for reason why product can't be promoted */
  reasonCode?: Maybe<Scalars['String']['output']>;
  /** The title of promotion. */
  title: Scalars['String']['output'];
};

export type CargoDeliveryRestriction = {
  __typename?: 'CargoDeliveryRestriction';
  /** Restriction text */
  text: Scalars['String']['output'];
  /** Restriction title */
  title: Scalars['String']['output'];
};

/** DEPRECATED, use RootCatalog instead */
export type Catalog = {
  __typename?: 'Catalog';
  /** id* of Catalog */
  id: Scalars['Int']['output'];
  /** Mark catalog as adult only */
  isAdultOnly?: Maybe<Scalars['Boolean']['output']>;
  isAllowedPriceVariation: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use RootCatalog.namespaceInfo.image field instead */
  photo?: Maybe<Scalars['String']['output']>;
  /** Slug is unique so it uses instead of primary key   */
  slug: Scalars['String']['output'];
};

/** An enumeration. */
export enum CatalogNamespaces {
  Aksesuary = 'AKSESUARY',
  Auto = 'AUTO',
  Building = 'BUILDING',
  Cosmetics = 'COSMETICS',
  Electronics = 'ELECTRONICS',
  Forkids = 'FORKIDS',
  Garden = 'GARDEN',
  Home = 'HOME',
  Kids = 'KIDS',
  Men = 'MEN',
  Pet = 'PET',
  Sport = 'SPORT',
  Women = 'WOMEN'
}

/**
 * This is internal object which need to debug scoring params for the each
 * particular product in the product's feed.
 */
export type CatalogScore = {
  __typename?: 'CatalogScore';
  brand: Scalars['Float']['output'];
  brandScore: Scalars['Float']['output'];
  conversionDialogue: Scalars['Float']['output'];
  conversionDialogueScore: Scalars['Float']['output'];
  conversionSale: Scalars['Float']['output'];
  conversionSaleScore: Scalars['Float']['output'];
  ctr: Scalars['Float']['output'];
  ctrScore: Scalars['Float']['output'];
  currentScore?: Maybe<Scalars['Float']['output']>;
  isNewSeller: Scalars['Boolean']['output'];
  isTopSeller: Scalars['Boolean']['output'];
  newScore: Scalars['Float']['output'];
  saleOrPromoAction: Scalars['Float']['output'];
  saleOrPromoActionScore: Scalars['Float']['output'];
  time: Scalars['Float']['output'];
  timeScore: Scalars['Float']['output'];
};

/** Params which use for calculate total_score */
export type CatalogScoreParams = {
  __typename?: 'CatalogScoreParams';
  brandWeight?: Maybe<Scalars['Float']['output']>;
  conversionDialogueWeight?: Maybe<Scalars['Float']['output']>;
  conversionSaleWeight?: Maybe<Scalars['Float']['output']>;
  ctrWeight?: Maybe<Scalars['Float']['output']>;
  saleOrPromoActionWeight?: Maybe<Scalars['Float']['output']>;
  timeWeight?: Maybe<Scalars['Float']['output']>;
};

/**
 * Return catalog structure.
 * class Catalog:
 *   name: str
 *   slug: str
 *   subCatalogs: Catalog[]
 */
export type CatalogTree = {
  __typename?: 'CatalogTree';
  /** Catalog structure in JSON representation. */
  catalogTree?: Maybe<Scalars['JSONStringWithoutAscii']['output']>;
  /** Outlet Catalog structure in JSON representation. */
  outletCatalogTree?: Maybe<Scalars['JSONString']['output']>;
  /** Latest catalog structure version */
  version?: Maybe<Scalars['Int']['output']>;
};


/**
 * Return catalog structure.
 * class Catalog:
 *   name: str
 *   slug: str
 *   subCatalogs: Catalog[]
 */
export type CatalogTreeCatalogTreeArgs = {
  version?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Return catalog structure.
 * class Catalog:
 *   name: str
 *   slug: str
 *   subCatalogs: Catalog[]
 */
export type CatalogTreeOutletCatalogTreeArgs = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** An enumeration. */
export enum ChangePriceMethod {
  Decrease = 'DECREASE',
  Increase = 'INCREASE'
}

/** An enumeration. */
export enum ChangePriceType {
  Absolute = 'ABSOLUTE',
  Percentage = 'PERCENTAGE'
}

export type ChangeProductPrice = {
  __typename?: 'ChangeProductPrice';
  /** DeactivateProducts errors */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

/** City type. */
export type City = {
  __typename?: 'City';
  /** city id */
  id: Scalars['Int']['output'];
  /** city name */
  name: Scalars['String']['output'];
  /** City name in where as answer on question 'where' (Київ->Києві, Рівне->Рівному) */
  nameWhere?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

export type CollectionType = {
  __typename?: 'CollectionType';
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  modifiedAt?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<User>;
  products?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  productsList?: Maybe<FeedConnection>;
  redirectTo?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};


export type CollectionTypeProductsListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Enum with collections ids */
export enum CollectionsEnum {
  PopularProducts = 'POPULAR_PRODUCTS'
}

/** Color type. */
export type Color = {
  __typename?: 'Color';
  /** string representation of the ColorEnum */
  enum: ColorEnum;
  /** color value in hex format without `#` */
  hex: Scalars['String']['output'];
  /** color id */
  id: Scalars['Int']['output'];
  /** If color is indexed, then it has dedicated indexed catalog page for bots */
  isIndexed: Scalars['Boolean']['output'];
  /** color name */
  name: Scalars['String']['output'];
};


/** Color type. */
export type ColorIsIndexedArgs = {
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
};

export enum ColorEnum {
  Beige = 'BEIGE',
  Black = 'BLACK',
  Blue = 'BLUE',
  Brown = 'BROWN',
  Burgundy = 'BURGUNDY',
  Coral = 'CORAL',
  Cyan = 'CYAN',
  Golden = 'GOLDEN',
  Gray = 'GRAY',
  Green = 'GREEN',
  Khaki = 'KHAKI',
  LightGreen = 'LIGHT_GREEN',
  Lilac = 'LILAC',
  Multicolor = 'MULTICOLOR',
  Mustard = 'MUSTARD',
  Orange = 'ORANGE',
  Peach = 'PEACH',
  Pink = 'PINK',
  Purple = 'PURPLE',
  Red = 'RED',
  Silver = 'SILVER',
  Turquoise = 'TURQUOISE',
  White = 'WHITE',
  Yellow = 'YELLOW'
}

/** A color filter type. Id can be used for filtering. */
export type ColorType = {
  __typename?: 'ColorType';
  /** string representation of the ColorEnum */
  enum: ColorEnum;
  /** color value in hex format without `#` */
  hex: Scalars['String']['output'];
  /** color id */
  id: Scalars['Int']['output'];
  /** If color is indexed, then it has dedicated indexed catalog page for bots */
  isIndexed: Scalars['Boolean']['output'];
  /** color name */
  name: Scalars['String']['output'];
};


/** A color filter type. Id can be used for filtering. */
export type ColorTypeIsIndexedArgs = {
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
};

/** Mutation for user complaint creation */
export type Complaint = {
  __typename?: 'Complaint';
  /** Create product errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess: Scalars['Boolean']['output'];
};

/** Complaint(both user and product) type object */
export type ComplaintType = {
  __typename?: 'ComplaintType';
  /** *id* of Complaint choice */
  id: Scalars['Int']['output'];
  /** *title* of Complaint Choice */
  title: Scalars['String']['output'];
};

/** Possible Complaint Types for user/product */
export type ComplaintTypesResponse = {
  __typename?: 'ComplaintTypesResponse';
  /**
   * Is complaint already sent
   * @deprecated The property to check if viewer can complain moved to `User` see `viewerCanComplain`
   */
  duplicate?: Maybe<Scalars['Boolean']['output']>;
  types: Array<ComplaintType>;
};

/** Condition type. */
export type Condition = {
  __typename?: 'Condition';
  /** string representation of the ConditionEnum */
  enum: ConditionEnum;
  /** condition id */
  id: Scalars['Int']['output'];
  /** condition name */
  name: Scalars['String']['output'];
};

export enum ConditionEnum {
  Alright = 'ALRIGHT',
  Good = 'GOOD',
  Ideal = 'IDEAL',
  New = 'NEW',
  VeryGood = 'VERY_GOOD'
}

/** A condition filter type. Id can be used for filtering. */
export type ConditionType = {
  __typename?: 'ConditionType';
  /** string representation of the ConditionEnum */
  enum: ConditionEnum;
  /** condition id */
  id: Scalars['Int']['output'];
  /** condition name */
  name: Scalars['String']['output'];
};

/** DEPRECATED */
export enum ConversionEnum {
  Good = 'GOOD'
}

/**
 * The mutation for creating dialog from current user to seller of product
 * witch given `product_id`.
 */
export type CreateDialog = {
  __typename?: 'CreateDialog';
  /** Create dialogs errors  . */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** The representation of created dialog  . */
  thread?: Maybe<Thread>;
};

/** The mutation for creating message from current user to some existing dialog */
export type CreateMessage = {
  __typename?: 'CreateMessage';
  /** Create message errors  . */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Message>;
};

/**
 * Create or Update promo action for user
 *
 * Create promo action before adding a product to the promo
 *
 * Error codes:
 *     - invalid_condition_value - invalid value for condition
 */
export type CreateOrUpdatePromoAction = {
  __typename?: 'CreateOrUpdatePromoAction';
  /** Promo actions error */
  errors?: Maybe<Array<GraphResponseError>>;
};

export type CreatePriceVariantType = {
  price: Scalars['MoneyType']['input'];
  sizeId: Scalars['Int']['input'];
};

/**
 * Mutation for product creation.
 * Possible error codes:
 *     - invalid: A generic error occurred
 *     - deactivated_user: The user account is deactivated
 *     - without_social_auth: User doesn't have social authentication
 *     - without_verified_phone: User's phone number is not verified
 *     - without_bank_id_verification: User is not verified through BankID
 *     - products_hard_limit_reached: User has
 *         reached the maximum allowed number of products
 */
export type CreateProduct = {
  __typename?: 'CreateProduct';
  createdProduct?: Maybe<ProductDetails>;
  /** Create product errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  /** @deprecated use created_product */
  product?: Maybe<Product>;
};

/** token or card_id are required */
export type CreateSubscriptionPayment = {
  __typename?: 'CreateSubscriptionPayment';
  data?: Maybe<ServicePaymentResponse>;
  errors?: Maybe<Array<GraphResponseError>>;
};

/**
 * This is the implementation of the way to create template messages for
 * current user.
 */
export type CreateTemplateMessage = {
  __typename?: 'CreateTemplateMessage';
  /** Create message errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export enum DailyEmailThresholdEnum {
  Five = 'FIVE',
  Once = 'ONCE',
  Ten = 'TEN',
  Twice = 'TWICE',
  Unlimited = 'UNLIMITED'
}

/**
 * This is the implementation of the way to deactivate sellers products.
 *
 * ### error_codes(for __all__ field):
 *
 * * __user_already_start_activation_deactivation__ - user can't start new
 *     deactivation before the previous finished
 */
export type DeactivateProducts = {
  __typename?: 'DeactivateProducts';
  /** DeactivateProducts errors */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

/** User debt level */
export enum DebtLevels {
  /** Balance less than 0 */
  Critical = 'CRITICAL'
}

/**
 * This is the implementation of the way to decline
 * potential deal by owner of the product
 */
export type DeclinePotentialDeal = {
  __typename?: 'DeclinePotentialDeal';
  /** Upload photo errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

/** The mutation for moving dialog to archive. */
export type DeleteDialog = {
  __typename?: 'DeleteDialog';
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

/** This is the implementation of the way to remove product by owner. */
export type DeleteProduct = {
  __typename?: 'DeleteProduct';
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteTemplateMessage = {
  __typename?: 'DeleteTemplateMessage';
  /** Delete message errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

/**
 *
 *     Don't forget to change price on Basket side when change description for
 *     delivery services.
 *     Class has the same name on Basket.
 *
 */
export enum DeliveryService {
  /** від 70 грн */
  Justin = 'JUSTIN',
  /** 50 грн (до 10 кг), 135 грн (понад 10 кг) */
  Meest = 'MEEST',
  /** від 70 грн */
  NovaPoshta = 'NOVA_POSHTA',
  /** 49 грн */
  Rozetka = 'ROZETKA',
  /** 35 грн (до 5 кг), 100 грн (понад 5 кг) */
  UkrPoshta = 'UKR_POSHTA'
}

export type DeliveryServiceType = {
  __typename?: 'DeliveryServiceType';
  icon: Scalars['StaticUrlType']['output'];
  title: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type DeliveryTariffType = {
  __typename?: 'DeliveryTariffType';
  icon: Scalars['StaticUrlType']['output'];
  title: Scalars['String']['output'];
};

export type DetailType = {
  __typename?: 'DetailType';
  icon: Scalars['StaticUrlType']['output'];
  items: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** This type need for represent data connected with dynamic collections. */
export type DynamicCollection = {
  __typename?: 'DynamicCollection';
  /** Collection brands filter */
  brands: Array<Brand>;
  /** Collection catalogs filter */
  catalogs: Array<Catalog>;
  /** *description* of current collection */
  description?: Maybe<Scalars['String']['output']>;
  /** Mininal discount */
  discountFrom: Scalars['Decimal']['output'];
  /** *id* of current collection */
  id: Scalars['Int']['output'];
  /** *url to image* of current collection */
  image?: Maybe<Scalars['String']['output']>;
  /** Brand filter on collection page is enabled */
  isBrandFilterEnable: Scalars['Boolean']['output'];
  /** Color filter on collection page is enabled */
  isColorFilterEnable: Scalars['Boolean']['output'];
  /** Condition filter on collection page is enabled */
  isConditionFilterEnable: Scalars['Boolean']['output'];
  /** Price filter on collection page is enabled */
  isPriceFilterEnable: Scalars['Boolean']['output'];
  /** Size filter on collection page is enabled */
  isSizeFilterEnable: Scalars['Boolean']['output'];
  /**
   *
   *     Return list of products for some catalog, by default return
   *     products form women catalog.
   *
   *     By default return only first 10 items. For get other products using
   *     pagination.
   *
   *     {
   *       products(first: 10) {
   *         edges {
   *           node {
   *             id
   *           }
   *           cursor # not necessary
   *         }
   *         pageInfo {
   *           hasNextPage
   *           hasPreviousPage
   *           startCursor
   *           endCursor
   *           total
   *         }
   *       }
   *     }
   *
   *     If you want get next page, test if hasNextPage is True and next
   *     using some code like bellow:
   *
   *
   *     {
   *       products(first: 10, after: `your previous endCursor value`) {
   *         edges {
   *           node {
   *             id
   *           }
   *         }
   *         pageInfo {
   *           hasNextPage
   *           hasPreviousPage
   *           startCursor
   *           endCursor
   *           total
   *         }
   *       }
   *     }
   *
   */
  products: FeedConnection;
  slug: Scalars['String']['output'];
  /** *title* of current collection */
  title: Scalars['String']['output'];
};


/** This type need for represent data connected with dynamic collections. */
export type DynamicCollectionProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brands?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  characteristics?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  paginationType?: InputMaybe<ProductPaginationType>;
  priceFrom?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priceTo?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ukrainian?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DynamicCollectionCustom = {
  __typename?: 'DynamicCollectionCustom';
  /** Collection brands filter */
  brands: Array<Brand>;
  /** Collection catalogs filter */
  catalogs: Array<Catalog>;
  /** *description* of current collection */
  description?: Maybe<Scalars['String']['output']>;
  /** Mininal discount */
  discountFrom: Scalars['Decimal']['output'];
  /** *id* of current collection */
  id: Scalars['Int']['output'];
  /** *url to image* of current collection */
  image?: Maybe<Scalars['String']['output']>;
  /** Brand filter on collection page is enabled */
  isBrandFilterEnable: Scalars['Boolean']['output'];
  /** Color filter on collection page is enabled */
  isColorFilterEnable: Scalars['Boolean']['output'];
  /** Condition filter on collection page is enabled */
  isConditionFilterEnable: Scalars['Boolean']['output'];
  /** Price filter on collection page is enabled */
  isPriceFilterEnable: Scalars['Boolean']['output'];
  /** Size filter on collection page is enabled */
  isSizeFilterEnable: Scalars['Boolean']['output'];
  /**
   *
   *     Return list of products for some catalog, by default return
   *     products form women catalog.
   *
   *     By default return only first 10 items. For get other products using
   *     pagination.
   *
   *     {
   *       products(first: 10) {
   *         edges {
   *           node {
   *             id
   *           }
   *           cursor # not necessary
   *         }
   *         pageInfo {
   *           hasNextPage
   *           hasPreviousPage
   *           startCursor
   *           endCursor
   *           total
   *         }
   *       }
   *     }
   *
   *     If you want get next page, test if hasNextPage is True and next
   *     using some code like bellow:
   *
   *
   *     {
   *       products(first: 10, after: `your previous endCursor value`) {
   *         edges {
   *           node {
   *             id
   *           }
   *         }
   *         pageInfo {
   *           hasNextPage
   *           hasPreviousPage
   *           startCursor
   *           endCursor
   *           total
   *         }
   *       }
   *     }
   *
   */
  products: FeedConnection;
  slug: Scalars['String']['output'];
  /** *title* of current collection */
  title: Scalars['String']['output'];
};


export type DynamicCollectionCustomProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brands?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  characteristics?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  feedScore?: InputMaybe<FeedScoreInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  paginationType?: InputMaybe<ProductPaginationType>;
  priceFrom?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priceTo?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ukrainian?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Provides the ability to edit user's settings connected with notifications. */
export type EditNotificationSettings = {
  __typename?: 'EditNotificationSettings';
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

/** Mutation for edit existed product */
export type EditProduct = {
  __typename?: 'EditProduct';
  createdProduct?: Maybe<ProductDetails>;
  /** Edit product errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  /** @deprecated use created_product */
  product?: Maybe<Product>;
};

/**
 * Provides the ability to edit user's profile settings.
 * If u need to download user picture add to your request the file to
 * `picture` field.
 */
export type EditProfileSettings = {
  __typename?: 'EditProfileSettings';
  /** Edit profile errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** Updated user */
  user?: Maybe<User>;
};

export type FeedConnection = {
  __typename?: 'FeedConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FeedEdge>>;
  /** The list of leaf categories for current feed. */
  leafCategories?: Maybe<Array<FeedLeafCategoriesType>>;
  /** Most frequent catalog from the results */
  mostFrequentCatalogSlug?: Maybe<Scalars['String']['output']>;
  pageInfo: PageInfo;
  /** The list of top level categories for current feed. */
  topLevelCategories?: Maybe<Array<TopLevelCategory>>;
};

/** A Relay edge containing a `Feed` and its cursor. */
export type FeedEdge = {
  __typename?: 'FeedEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Product>;
};

export type FeedLeafCategoriesType = {
  __typename?: 'FeedLeafCategoriesType';
  catalog: RootCatalog;
  /** Amount of products */
  count: Scalars['Int']['output'];
};

/** Information about promotion on product from feed */
export type FeedProductPromotion = {
  __typename?: 'FeedProductPromotion';
  promotionName: Scalars['String']['output'];
  promotionType: ProductPromotionTypeEnum;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type FeedScoreInput = {
  brandWeight?: InputMaybe<Scalars['Float']['input']>;
  conversionDialogueWeight?: InputMaybe<Scalars['Float']['input']>;
  conversionSaleWeight?: InputMaybe<Scalars['Float']['input']>;
  ctrWeight?: InputMaybe<Scalars['Float']['input']>;
  saleOrPromoActionWeight?: InputMaybe<Scalars['Float']['input']>;
  timeWeight?: InputMaybe<Scalars['Float']['input']>;
};

export type FeedSeoTagProductConnection = {
  __typename?: 'FeedSeoTagProductConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FeedSeoTagProductEdge>>;
  /** Most frequent catalog from the results */
  mostFrequentCatalogSlug?: Maybe<Scalars['String']['output']>;
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FeedSeoTagProduct` and its cursor. */
export type FeedSeoTagProductEdge = {
  __typename?: 'FeedSeoTagProductEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Product>;
};

/**
 * Catalog for filtering on
 * profile(both viewer and user) and products_by_subscriptions page
 */
export type FilterCatalog = {
  __typename?: 'FilterCatalog';
  alsoSearchCrossLinking: Array<SeoTag>;
  breadcrumbs: Array<RootCatalog>;
  characteristics: Array<ProductCharacteristic>;
  /** Full path for category in format like "Apparel & Accessories > Clothing > Dresses" */
  googleProductCategory?: Maybe<Scalars['String']['output']>;
  /** The id of google product category */
  googleProductCategoryId?: Maybe<Scalars['Int']['output']>;
  /** The id of current catalog */
  id: Scalars['String']['output'];
  /** Mark catalog as adult only */
  isAdultOnly: Scalars['Boolean']['output'];
  isColorRequired: Scalars['Boolean']['output'];
  /** Meta description for catalog */
  metaDescription: Scalars['String']['output'];
  /** Meta title for catalog */
  metaTitle: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**
   * Catalog namespace. Not provided for root catalog
   * @deprecated Use namespaceInfo field instead
   */
  namespace?: Maybe<CatalogNamespaces>;
  /** Catalog namespace. Not provided for root catalog */
  namespaceInfo?: Maybe<Namespace>;
  path?: Maybe<Scalars['String']['output']>;
  /** Count of products in current catalog   */
  productsCount: Scalars['Int']['output'];
  /** Redirect url */
  redirectTo?: Maybe<Scalars['String']['output']>;
  sales: Array<GraphSale>;
  /** Seo description for catalog (It's not META description !!!) */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** Seo title for catalog (It's not META title !!!) */
  seoTitle?: Maybe<Scalars['String']['output']>;
  siblings: Array<RootCatalog>;
  sizeGroup?: Maybe<SizeGroupType>;
  /** Slug is unique so it uses instead of primary key   */
  slug: Scalars['String']['output'];
  subCatalogs?: Maybe<Array<FilterCatalog>>;
  tagGroupCrossLinking: Array<SeoTagGroupCrossLinking>;
  url: Scalars['String']['output'];
};


/**
 * Catalog for filtering on
 * profile(both viewer and user) and products_by_subscriptions page
 */
export type FilterCatalogAlsoSearchCrossLinkingArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Catalog for filtering on
 * profile(both viewer and user) and products_by_subscriptions page
 */
export type FilterCatalogCharacteristicsArgs = {
  hideInternal?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Catalog for filtering on
 * profile(both viewer and user) and products_by_subscriptions page
 */
export type FilterCatalogMetaDescriptionArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<IndexedFilterInput>;
};


/**
 * Catalog for filtering on
 * profile(both viewer and user) and products_by_subscriptions page
 */
export type FilterCatalogMetaTitleArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<IndexedFilterInput>;
};


/**
 * Catalog for filtering on
 * profile(both viewer and user) and products_by_subscriptions page
 */
export type FilterCatalogNameArgs = {
  filter?: InputMaybe<IndexedFilterInput>;
};


/**
 * Catalog for filtering on
 * profile(both viewer and user) and products_by_subscriptions page
 */
export type FilterCatalogSeoDescriptionArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<IndexedFilterInput>;
};


/**
 * Catalog for filtering on
 * profile(both viewer and user) and products_by_subscriptions page
 */
export type FilterCatalogSeoTitleArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<IndexedFilterInput>;
};

export type FraudInfo = {
  __typename?: 'FraudInfo';
  /** Does any user matched by specified arguments? */
  hasInfo: Scalars['Boolean']['output'];
};


export type FraudInfoHasInfoArgs = {
  cardNumber?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type FreeDeliveryService = {
  __typename?: 'FreeDeliveryService';
  icon: Scalars['StaticUrlType']['output'];
  title: Scalars['String']['output'];
};

export type FreeShippingInfoType = {
  __typename?: 'FreeShippingInfoType';
  deliveryServices: Array<Maybe<FreeDeliveryService>>;
  description: Scalars['String']['output'];
  /** End date of the free shipping */
  endDate: Scalars['DateTime']['output'];
  /** Free delivery landing id */
  landingSlug: Scalars['String']['output'];
  type: FreeShippingType;
};

/** An enumeration. */
export enum FreeShippingType {
  First = 'first',
  Second = 'second',
  Third = 'third'
}

/** An enumeration. */
export enum FrequencyType {
  Daily = 'daily',
  Monthly = 'monthly',
  Weekly = 'weekly',
  Yearly = 'yearly'
}

export enum GenderEnum {
  GenderFemale = 'GENDER_FEMALE',
  GenderMale = 'GENDER_MALE'
}

export type GraphErrorMessage = {
  __typename?: 'GraphErrorMessage';
  /** error code */
  code: Scalars['String']['output'];
  /** error message */
  message: Scalars['String']['output'];
};

export type GraphResponseError = {
  __typename?: 'GraphResponseError';
  /** field where error occurred or `__all__` if field does not exist */
  field: Scalars['String']['output'];
  /** List of error message objects */
  messages: Array<GraphErrorMessage>;
  /** error payload */
  payload?: Maybe<Scalars['String']['output']>;
};

/**
 * Common Sale shema
 * for use in context of Graph
 */
export type GraphSale = {
  __typename?: 'GraphSale';
  banner: SaleBannerType;
  /** Sale-related collection */
  collection: DynamicCollection;
  endDate: Scalars['Date']['output'];
  /** Highlighting for product page */
  highlighting?: Maybe<GraphSaleHighlighting>;
  id: Scalars['Int']['output'];
  /** Does current user participates in sale? */
  isViewerParticipates: Scalars['Boolean']['output'];
  startDate: Scalars['Date']['output'];
  /** Sale start time */
  startTime: Scalars['String']['output'];
  title: Scalars['String']['output'];
  /** Count of products matched for sale */
  viewerMatchedProductsCount: Scalars['Int']['output'];
};

export type GraphSaleHighlighting = {
  __typename?: 'GraphSaleHighlighting';
  /** In hex format. #ffffff */
  color: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Hide fraud warnings in chat messages */
export type HideChatMessagesFraudWarnings = {
  __typename?: 'HideChatMessagesFraudWarnings';
  errors?: Maybe<Array<GraphResponseError>>;
};

export type IndexedFilterInput = {
  brandId?: InputMaybe<Scalars['Int']['input']>;
  characteristicChoiceId?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<Scalars['Int']['input']>;
};

export type LinkedCatalog = BaseLinkedCatalog & {
  __typename?: 'LinkedCatalog';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type LinkedCatalogUnion = LinkedCatalog | LinkedVirtualCatalog;

export type LinkedVirtualCatalog = BaseLinkedCatalog & {
  __typename?: 'LinkedVirtualCatalog';
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type LogoImage = {
  __typename?: 'LogoImage';
  /** Image of Android logo. */
  imageAndroid: Scalars['String']['output'];
  /** Image of IOS logo. */
  imageIos: Scalars['String']['output'];
  /** Image of of web logo. */
  imageWeb: Scalars['String']['output'];
  /** Logo is active */
  isActive: Scalars['Boolean']['output'];
  /** Title of logo. */
  title: Scalars['String']['output'];
};

/**
 * Representation information connected with a one slide of the banner on the
 * main page.
 */
export type MainSlide = {
  __typename?: 'MainSlide';
  id: Scalars['Int']['output'];
  /** Main image of the current slide. */
  image: SlideImage;
  /** Image that should be used on product details screen */
  productDetailsImage: SlideImage;
  /** The main text of the current slide. */
  title: Scalars['String']['output'];
  /** The url connected to slide */
  url: Scalars['String']['output'];
};

export type MainSlider = {
  __typename?: 'MainSlider';
  /** The slides of the slider on main page. */
  slides: Array<MainSlide>;
};


export type MainSliderSlidesArgs = {
  forMobileApps?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarkAllNotificationsAsReadMutation = {
  __typename?: 'MarkAllNotificationsAsReadMutation';
  errors?: Maybe<Array<GraphResponseError>>;
};

export type MarkNotificationsAsReadMutation = {
  __typename?: 'MarkNotificationsAsReadMutation';
  notification: Notification;
};

/**
 *
 *         This is the implementation of the way to check product as sold. In this
 *         method u can choose buyer of product.
 *
 *         Error codes:
 *         1. "sale_confirmation_required" - user sale confirmation required;
 *         2. "not_enough_money_for_cpa" - not enough money for sale;
 *         3. "too_big_discount" - too big discount;
 *         4. "duplicate_order_transaction" - transaction for such order
 *            already exists
 *         (can be raised only when order provided)
 *         5. "pbr_order" - attempt to mark sold product that was bought
 *            through PBR order
 *         6. "error_code_duplicate_mark" - attempt to mark sold product twice
 *
 */
export type MarkProductAsSold = {
  __typename?: 'MarkProductAsSold';
  /** Upload photo errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** Updated product */
  product?: Maybe<ProductDetails>;
};

/** The main object for representation data connected with message. */
export type Message = {
  __typename?: 'Message';
  /** Additional component for message */
  additionalComponent: MessageAdditionalComponent;
  /** The text of the current message. */
  body: Scalars['String']['output'];
  /**
   * Warning for user that this message contain contacts. May be `None`if message does not contain contacts or user should not see anywarnings about contact.
   * @deprecated Use `sub_text` field instead of this
   */
  contactsWarning?: Maybe<Scalars['String']['output']>;
  /** HTML string with info about contacts and potential fraud.Multiple messages in thread may contain the same fraud warning. */
  fraudWarning?: Maybe<Scalars['String']['output']>;
  /** The id of the current message. */
  id: Scalars['Int']['output'];
  /**
   * @client field
   * True if send message mutation was sent and waiting for response
   */
  isScheduleToSend?: Maybe<Scalars['Boolean']['output']>;
  /** Its true if system sent this message */
  isSystemMessage: Scalars['Boolean']['output'];
  /** Info for link button */
  linkButton?: Maybe<MessageLinkButton>;
  /** Its order id which describe in message */
  orderId?: Maybe<Scalars['Int']['output']>;
  /** Urls of photos that have been attached to the current message. */
  photos: Array<Scalars['String']['output']>;
  /** The product that connected with current message. */
  product?: Maybe<ProductDetails>;
  /** The user who sent the current message. */
  sender: User;
  /** The date when the current message was sent. */
  sentAt: Scalars['String']['output'];
  /** Information text bellow message */
  subText?: Maybe<Scalars['String']['output']>;
  /** Info text if user can get get participant's phone number via retrieveOrderPhone mutation */
  viewPhoneText?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum MessageAdditionalComponent {
  LeaveReview = 'LEAVE_REVIEW',
  None = 'NONE',
  OrderDetailButton = 'ORDER_DETAIL_BUTTON',
  SmartProposal = 'SMART_PROPOSAL',
  TrackingLink = 'TRACKING_LINK'
}

export type MessageByProductInput = {
  /** The text of the current message. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** The id of the current product. */
  product: Scalars['Int']['input'];
  /** The id of selected size. */
  selectedSizeId?: InputMaybe<Scalars['Int']['input']>;
};

export type MessageByRecipientInput = {
  /** The text of the current message. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** The id of the recipient. */
  recipient: Scalars['Int']['input'];
  /** The subject of the future dialog. */
  subject: Scalars['String']['input'];
};

export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MessageEdge>>;
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Message` and its cursor. */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Message>;
};

export type MessageLinkButton = {
  __typename?: 'MessageLinkButton';
  /** Link for button */
  link: Scalars['String']['output'];
  /** Button text */
  text: Scalars['String']['output'];
};

export type MessageUtmLabelsInput = {
  /** Utm campaign label. */
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  /** Utm medium label. */
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  /** Utm Source label. */
  utmSource?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum MiddleResponseTime {
  Time_1D = 'TIME_1D',
  Time_1H = 'TIME_1H',
  Time_3D = 'TIME_3D',
  Time_3H = 'TIME_3H',
  Time_6H = 'TIME_6H',
  Time_7D = 'TIME_7D',
  Time_12H = 'TIME_12H',
  Time_15Min = 'TIME_15MIN',
  Time_30D = 'TIME_30D',
  SupperSellerValue = 'supper_seller_value'
}

/** A GraphQL schema for each kind of mutation. */
export type Mutation = {
  __typename?: 'Mutation';
  /**
   * This is the implementation of the way to Activate seller products.
   *
   * ### error_codes(field '\__all\__'):
   *
   * * __user_already_start_activation_deactivation__ - user can't start new
   *     deactivation before the previous finished
   *
   * * __base_user_activate_more_than_soft_limit__ - base user can have <=50
   *     active products
   *
   * * __pro_user_choose_free_products__ - pro user firstly must select free products
   */
  activateProducts?: Maybe<ActivateProducts>;
  /** The mutation make dialog important for current user. */
  addDialogImportant?: Maybe<AddDialogImportant>;
  /**
   * This is the implementation of adding promo for the product
   *
   * **Before adding a product, make sure that promotion is created**
   *
   * Error codes:
   *     - promo_action_not_created - Promo action is not created
   *     - already_adding_removing - task for adding product to promo
   *       action already created
   *     - one_of_error - invalid params for mutation(required on of includeIds,
   *       excludeIds, allProducts)
   *     - params_both_error - invalid params, too many params, only 1 required
   */
  addPromoActionForProducts?: Maybe<AddPromoMutation>;
  /**
   * This is the implementation of the way to bulk add the products to the
   * user's favorites.
   *
   * Method add only favourites which are not active.
   */
  addToFavourites: AddFavourites;
  /**
   * This is the implementation of the way to add user into follower list for
   * the current user.
   */
  addToFollower?: Maybe<AddToFollower>;
  /** Mutation for associating Firebase token with user. */
  associateDevice?: Maybe<AssociateDevice>;
  /** The mutation add dialog to black list by current user. */
  blockDialog?: Maybe<BlockDialogMutation>;
  changeProductPrice?: Maybe<ChangeProductPrice>;
  /** Mutation for user complaint creation */
  createComplaint: Complaint;
  /**
   * The mutation for creating dialog from current user to seller of product
   * witch given `product_id`.
   */
  createDialog?: Maybe<CreateDialog>;
  /** The mutation for creating message from current user to some existing dialog */
  createMessage?: Maybe<CreateMessage>;
  /**
   * Create or Update promo action for user
   *
   * Create promo action before adding a product to the promo
   *
   * Error codes:
   *     - invalid_condition_value - invalid value for condition
   */
  createOrUpdatePromoAction?: Maybe<CreateOrUpdatePromoAction>;
  /**
   * Mutation for product creation.
   * Possible error codes:
   *     - invalid: A generic error occurred
   *     - deactivated_user: The user account is deactivated
   *     - without_social_auth: User doesn't have social authentication
   *     - without_verified_phone: User's phone number is not verified
   *     - without_bank_id_verification: User is not verified through BankID
   *     - products_hard_limit_reached: User has
   *         reached the maximum allowed number of products
   */
  createProduct?: Maybe<CreateProduct>;
  /** token or card_id are required */
  createSubscriptionPayment: CreateSubscriptionPayment;
  /**
   * This is the implementation of the way to create template messages for
   * current user.
   */
  createTemplateMessage?: Maybe<CreateTemplateMessage>;
  /**
   * This is the implementation of the way to deactivate sellers products.
   *
   * ### error_codes(for __all__ field):
   *
   * * __user_already_start_activation_deactivation__ - user can't start new
   *     deactivation before the previous finished
   */
  deactivateProducts?: Maybe<DeactivateProducts>;
  /**
   * This is the implementation of the way to decline
   * potential deal by owner of the product
   */
  declinePotentialDeal?: Maybe<DeclinePotentialDeal>;
  /** The mutation for moving dialog to archive. */
  deleteDialog?: Maybe<DeleteDialog>;
  /** This is the implementation of the way to remove product by owner. */
  deleteProduct?: Maybe<DeleteProduct>;
  deleteTemplateMessage?: Maybe<DeleteTemplateMessage>;
  /**
   * Provides the ability to edit user's settings connected with notifications.
   * @deprecated User edit_notification_settings from v4 api
   */
  editNotificationSettings?: Maybe<EditNotificationSettings>;
  /** Mutation for edit existed product */
  editProduct?: Maybe<EditProduct>;
  /**
   * Provides the ability to edit user's profile settings.
   * If u need to download user picture add to your request the file to
   * `picture` field.
   */
  editProfileSettings?: Maybe<EditProfileSettings>;
  /** Hide fraud warnings in chat messages */
  hideChatMessagesFraudWarnings?: Maybe<HideChatMessagesFraudWarnings>;
  markAllNotificationAsRead: MarkAllNotificationsAsReadMutation;
  markNotificationAsRead: MarkNotificationsAsReadMutation;
  /**
   *
   *         This is the implementation of the way to check product as sold. In this
   *         method u can choose buyer of product.
   *
   *         Error codes:
   *         1. "sale_confirmation_required" - user sale confirmation required;
   *         2. "not_enough_money_for_cpa" - not enough money for sale;
   *         3. "too_big_discount" - too big discount;
   *         4. "duplicate_order_transaction" - transaction for such order
   *            already exists
   *         (can be raised only when order provided)
   *         5. "pbr_order" - attempt to mark sold product that was bought
   *            through PBR order
   *         6. "error_code_duplicate_mark" - attempt to mark sold product twice
   *
   */
  markProductAsSold?: Maybe<MarkProductAsSold>;
  /**
   * Applies sale participation
   * for current user
   *
   * errors:
   *  - bad_discount - some products has bad discount.
   *   Payload field have min discount that suitable for all products
   */
  participateInSale?: Maybe<ParticipateInSale>;
  /**
   * This is the implementation of the way to authorize via login and password
   *
   * ### error_codes(field 'username'):
   *
   * * __max_length__ - Username length more than 254 characters
   *
   * ### error_codes(field '\__all\__'):
   *
   * * __invalid_login__ - wrong password or username
   *
   * * __authorization_requests_limit__ - too many requests
   *
   * * __inactive__ - User deleted
   */
  passwordAuthorization?: Maybe<PasswordAuthorization>;
  /**
   * Mutation for registration by phone
   *
   * ### error_codes(field 'username'):
   *
   * * __reg_username_illegal_chars__ - Username contains disallowed substring
   *  or bad first char or bad last char
   *
   * * __reg_username_is_tooshort__ - Too short
   *
   * * __reg_username_is_toolong__ - Too long
   *
   * * __reg_username_only_one_dot__ - Too many dots
   *
   * * __reg_username_toomuch_specchars__ - Too many special chars
   *
   * * __reg_username_contains_spaces__ - Username contains spaces
   *
   * * __reg_username_is_taken__ - Username already taken by another user
   *
   * ### error_codes(field 'email'):
   *
   * * __reg_email_invalid__ - Email is not valid
   *
   * ### error_codes(field '__all__'):
   *
   * * __reg_user_data_not_provided__ - Phone verification data not provided
   */
  phoneRegistration?: Maybe<PhoneRegistration>;
  /** Mutation for phone verification and save it */
  phoneVerification?: Maybe<PhoneVerification>;
  /**
   * Mutation for product complaint creation
   * TODO: delete after protobuf drop
   */
  productComplaint?: Maybe<ProductComplaint>;
  /**
   * Create user by login and phone number
   *
   * ### error_codes(field 'username'):
   *
   * * __reg_username_illegal_chars__ - Username contains disallowed substring
   *  or bad first char or bad last char
   *
   * * __reg_username_is_tooshort__ - Too short
   *
   * * __reg_username_is_toolong__ - Too long
   *
   * * __reg_username_only_one_dot__ - Too many dots
   *
   * * __reg_username_toomuch_specchars__ - Too many special chars
   *
   * * __reg_username_contains_spaces__ - Username contains spaces
   *
   * * __reg_username_is_taken__ - Username already taken by another user
   *
   * ### error_codes(field '__all__'):
   *
   * * __phone_does_not_verified__ - Phone does not verified
   * * __already_used__ - Phone already in use
   */
  promUserCreateUser?: Maybe<PromImportRegistration>;
  /**
   * Send sms on phone number
   *
   * ### error_codes(field `__all__`):
   * * __too_many_requests__ - To many request for send sms. 3 sms/10 min
   * * __invalid__ - Invalid phone number
   *
   * ### error_codes(field 'signature'):
   * * __invalid__ - invalid signature
   */
  promUserSendSms?: Maybe<PromSendSmsMutation>;
  /**
   * If phone number exist, mutation will return user_id of phone owner and account will
   * be verified, else mutation will return None
   *
   * ### error_codes(field `__all__`):
   * * __sms_does_not_sent__ - Sms does not send or data expired
   * * __attempt_reached__ - User reached attempt of enter code reached
   * * __code_invalid__ - Verification code is invalid
   */
  promUserVerifyPhone?: Maybe<PromImportSmsCodeVerification>;
  /** This is the implementation of promoting the product from user balance */
  promoteProductFromBalance?: Maybe<PromoteProductMutation>;
  /** This is the implementation of promoting the product from user balance */
  promoteProductWithPackageFromBalance?: Maybe<PromoteProductWithPromoPackageMutation>;
  /** The mutation remove important status of dialog for current user. */
  removeDialogImportant?: Maybe<RemoveDialogImportant>;
  /**
   * This is the implementation of the way to remove products from the user's
   * favorites. If products exist in favourites for current user it remove them,
   * else do nothing.
   */
  removeFromFavourites: RemoveFavourites;
  /**
   * This is the implementation of the way to remove user from follower list for
   * the current user.
   */
  removeFromFollower?: Maybe<RemoveToFollower>;
  /**
   * This is the implementation of removing promo for the product
   *
   * **Before adding/removing a product, make sure that promotion is created**
   *
   * Error codes:
   *     - promo_action_not_created - Promo action is not created
   *     - already_adding_removing - task for removing product to promo action
   *       already created
   *     - one_of_error - invalid params for mutation(required on of includeIds,
   *       excludeIds, allProducts)
   *     - params_both_error - invalid params, too many params, only 1 required
   */
  removePromoActionForProducts?: Maybe<RemovePromoMutation>;
  /**
   * Mutation for send sms password recovery
   *
   * ### error_codes(field 'phone_number'):
   * * __invalid__ - Bad phone format
   * * __is_not_used__ - Phone is not use
   *
   * ### error_codes(field '__all__'):
   * * __too_many_requests__ - User send too much sms
   */
  resendSms?: Maybe<ResetPasswordSendSms>;
  /** This mutation send email with link for restore password */
  resetPassword?: Maybe<ResetPassword>;
  /**
   * Mutation for send sms password recovery
   *
   * ### error_codes(field 'phone_number'):
   * * __invalid__ - Bad phone format
   * * __is_not_used__ - Phone is not use
   *
   * ### error_codes(field '__all__'):
   * * __too_many_requests__ - User send too much sms
   */
  resetPasswordSendSms?: Maybe<ResetPasswordSendSms>;
  /** Mutation for send sms */
  sendSms?: Maybe<SendSms>;
  /**
   * This is the implementation of the way to authorize via socials
   *
   * Used only by Mobile devices. For desktop we use OAuth authorization
   *
   * ### error_codes(field '\__all\__'):
   *
   * * __auth_unknown_social_service__ - Client provides wrong social service
   *
   * * __auth_no_such_user_registered__ - No such user registered
   *
   * * __auth_deleted_user__ - User deleted
   *
   * * __auth_social_service_not_responding__ - social service not responding
   */
  socialAuthorization?: Maybe<SocialAuthorization>;
  /**
   * User registration via socials
   *
   * ### error_codes(field 'email'):
   *
   * * __reg_email_registered__ - Email already registered
   *
   * * __reg_email_provider_is_blocked__ - Provided email is blocked
   *
   * ### error_codes(field 'username'):
   *
   * * __reg_username_illegal_chars__ - Username contains disallowed substring
   *  or bad first char or bad last char
   *
   * * __reg_username_is_tooshort__ - Too short
   *
   * * __reg_username_is_toolong__ - Too long
   *
   * * __reg_username_only_one_dot__ - Too many dots
   *
   * * __reg_username_toomuch_specchars__ - Too many special chars
   *
   * * __reg_username_contains_spaces__ - Username contains spaces
   *
   * * __reg_username_is_taken__ - Username already taken by another user
   *
   * ### error_codes(field 'service'):
   *
   * * __reg_unknown_social_service__ - Client provides wrong social service
   *
   * ### error_codes(field '__all__'):
   *
   * * __reg_invalid_social_token__ - Client provides wrong access token
   *
   * * __reg_social_user_registered__ - User already registered
   *
   * * __auth_social_service_not_responding__ - social service not responding
   */
  socialRegistration?: Maybe<SocialRegistration>;
  /**
   * Errors:
   *  max_suspend_amount - Max suspend amount
   */
  suspendPotentialDeal?: Maybe<SuspendPotentialDeal>;
  /** @deprecated Dont used */
  tofuSyncDisable?: Maybe<TofuSyncDisable>;
  /** @deprecated Dont used */
  tofuSyncEnable?: Maybe<TofuSyncEnable>;
  /**
   * Mutation for phone verification on registration step or password recovery
   *
   * ### error_codes(field 'verification_code'):
   * * __min_value__ - Verification code must contain 5 characters
   * * __max_value__ - Verification code must contain 5 characters
   * * __invalid__ - Enter a whole number
   *
   * ### error_codes(field '__all__'):
   * * __sms_does_not_sent__ - Need resend sms. User data expired or doesn't exist.
   * * __code_invalid__ - Sent and Provided codes don't match
   */
  unauthorizedPhoneVerification?: Maybe<UnauthorizedPhoneVerification>;
  /**
   * Mutation for send sms on registration step
   *
   * ### error_codes(field 'phone_number'):
   * * __invalid__ - Bad phone format
   * * __already_used__ - Phone already used by another user
   *
   * ### error_codes(field '__all__'):
   * * __too_many_requests__ - User send too much sms
   */
  unauthorizedSendSms?: Maybe<UnauthorizedSendSms>;
  /** The mutation remove dialog from black list by current user. */
  unblockDialog?: Maybe<UnblockDialogMutation>;
  updateAutoRenew: UpdateAutoRenew;
  /** This is the implementation of the way to change product's status by owner. */
  updateProductStatus?: Maybe<UpdateProductStatus>;
  /** Mutation for phone verification and save it */
  updateWorkStatus?: Maybe<UpdateWorkStatus>;
  /** Mutation for upload photo as attachment to message */
  uploadMessagePhoto?: Maybe<UploadMessagePhoto>;
  /** Mutation for upload photo in product create action */
  uploadPhoto?: Maybe<UploadPhoto>;
  uploadUserPhoto?: Maybe<UploadUserPhoto>;
  /**
   * Mutation for user complaint creation
   * TODO: delete after protobuf drop
   */
  userComplaint?: Maybe<UserComplaint>;
  /**
   * Soft delete the user or send a notification to the telegram chat if the user cannot
   * be deleted
   */
  userDelete?: Maybe<UserDelete>;
  /**
   * Mutation for reset password if user use email for restoring password
   * Client must send `activation_key` that user received in email,
   * `newPassword` and `confirmPassword`
   *
   *
   * ### error_codes(field '__password__'):
   * * __password_mismatch__ - Passwords do not match
   * * __password_is_short__ - Password is short
   * * __password_like_username_or_email__ - Password should not be like username or
   *     email
   *
   * ### error_codes(field '\__all\__'):
   * * __reset_link_expire__ - Reset password link is expire
   */
  userResetPasswordViaEmail?: Maybe<UserResetPasswordViaEmail>;
  /**
   * Mutation for reset password if user use phone for restoring password
   * Client must send `user_token` that client received
   * from server when verified phone,
   * `newPassword` and `confirmPassword`
   *
   * ### error_codes(field '__password__'):
   * * __password_mismatch__ - Passwords do not match
   * * __password_is_short__ - Password is short
   * * __password_like_username_or_email__ - Password should not be like username or
   *     email
   *
   *
   * ### error_codes(field '\__all\__'):
   * * __sms_does_not_sent__ - Need resend sms. User data expired or doesn't exist.
   */
  userResetPasswordViaPhone?: Maybe<UserResetPasswordViaPhone>;
  userTagsSuggests: Array<UserSeoTags>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationActivateProductsArgs = {
  allProducts?: InputMaybe<Scalars['Boolean']['input']>;
  excludeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  includeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationAddDialogImportantArgs = {
  dialogId: Scalars['Int']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationAddPromoActionForProductsArgs = {
  allProducts?: InputMaybe<Scalars['Boolean']['input']>;
  excludeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  includeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  promoType: PromoActionTypeEnum;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationAddToFavouritesArgs = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationAddToFollowerArgs = {
  userId: Scalars['Int']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationAssociateDeviceArgs = {
  deviceId: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationBlockDialogArgs = {
  threadId: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationChangeProductPriceArgs = {
  allProducts?: InputMaybe<Scalars['Boolean']['input']>;
  changePriceMethod: ChangePriceMethod;
  changePriceType: ChangePriceType;
  changePriceValue: Scalars['Int']['input'];
  excludeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  includeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationCreateComplaintArgs = {
  complaintText: Scalars['String']['input'];
  complaintType: Scalars['Int']['input'];
  email: Scalars['String']['input'];
  productId?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['Int']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationCreateDialogArgs = {
  allUtmLabels?: InputMaybe<Array<MessageUtmLabelsInput>>;
  product?: InputMaybe<MessageByProductInput>;
  recipient?: InputMaybe<MessageByRecipientInput>;
  utmLabels?: InputMaybe<MessageUtmLabelsInput>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationCreateMessageArgs = {
  body: Scalars['String']['input'];
  dialogId: Scalars['Int']['input'];
  photos?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationCreateOrUpdatePromoActionArgs = {
  condition: PromoConditionInput;
  promoType: PromoActionTypeEnum;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationCreateProductArgs = {
  additionalSizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  brand?: InputMaybe<Scalars['Int']['input']>;
  catalog: Scalars['String']['input'];
  characteristics?: InputMaybe<Array<Scalars['Int']['input']>>;
  colors: Array<InputMaybe<ColorEnum>>;
  condition: ConditionEnum;
  count?: InputMaybe<Scalars['Int']['input']>;
  delivery?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  description2?: InputMaybe<Scalars['String']['input']>;
  descriptionRu?: InputMaybe<Scalars['String']['input']>;
  descriptionUk?: InputMaybe<Scalars['String']['input']>;
  gtin?: InputMaybe<Scalars['String']['input']>;
  isMadeInUkraine?: InputMaybe<Scalars['Boolean']['input']>;
  isSelfMadeImageAdded?: InputMaybe<Scalars['Boolean']['input']>;
  isTermsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  isUkToRuTranslationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  keyWords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameRu?: InputMaybe<Scalars['String']['input']>;
  nameUk?: InputMaybe<Scalars['String']['input']>;
  phoneId?: InputMaybe<Scalars['String']['input']>;
  photosStr?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  price?: InputMaybe<Scalars['Int']['input']>;
  priceVariants?: InputMaybe<Array<CreatePriceVariantType>>;
  promotionType?: InputMaybe<PromotionTypeEnum>;
  sellingCondition: SellingConditionEnum;
  size?: InputMaybe<Scalars['Int']['input']>;
  userBrand?: InputMaybe<Scalars['Int']['input']>;
  videoOverview?: InputMaybe<Scalars['String']['input']>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationCreateSubscriptionPaymentArgs = {
  applePayToken?: InputMaybe<Scalars['String']['input']>;
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  cardId?: InputMaybe<Scalars['String']['input']>;
  fingerprint?: InputMaybe<PaymentFingerprint>;
  googlePayToken?: InputMaybe<Scalars['String']['input']>;
  planId?: InputMaybe<Scalars['Int']['input']>;
  resultUrl?: InputMaybe<Scalars['String']['input']>;
  resultUrlPayload?: InputMaybe<Array<ResultUrlPayloadType>>;
  subscriptionPlanId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationCreateTemplateMessageArgs = {
  body: Scalars['String']['input'];
  pk?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationDeactivateProductsArgs = {
  allProducts?: InputMaybe<Scalars['Boolean']['input']>;
  excludeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  includeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationDeclinePotentialDealArgs = {
  threadId: Scalars['Int']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationDeleteDialogArgs = {
  dialogId: Scalars['Int']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationDeleteProductArgs = {
  productId: Scalars['Int']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationDeleteTemplateMessageArgs = {
  pk: Scalars['Int']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationEditNotificationSettingsArgs = {
  dailyEmailThreshold?: InputMaybe<DailyEmailThresholdEnum>;
  onFeedback?: InputMaybe<Scalars['Boolean']['input']>;
  onFollower?: InputMaybe<Scalars['Boolean']['input']>;
  onFollowerNewProduct?: InputMaybe<Scalars['Boolean']['input']>;
  onMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  onMessage?: InputMaybe<Scalars['Boolean']['input']>;
  onStarred?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationEditProductArgs = {
  data: ProductInput;
  productId: Scalars['Int']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationEditProfileSettingsArgs = {
  about?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['Int']['input']>;
  dailyEmailThreshold?: InputMaybe<DailyEmailThresholdEnum>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<GenderEnum>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  patronymic?: InputMaybe<Scalars['String']['input']>;
  showRealName?: InputMaybe<ShowRealNameEnum>;
  showSocialWebSite?: InputMaybe<ShowSocialWebSiteEnum>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationMarkNotificationAsReadArgs = {
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  notificationIdStr?: InputMaybe<Scalars['String']['input']>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationMarkProductAsSoldArgs = {
  buyerId?: InputMaybe<Scalars['Int']['input']>;
  confirmSale?: InputMaybe<Scalars['Boolean']['input']>;
  potentialDeal?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['Int']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationParticipateInSaleArgs = {
  allProducts?: InputMaybe<Scalars['Boolean']['input']>;
  discount: Scalars['Decimal']['input'];
  excludeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  includeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  saleId: Scalars['Int']['input'];
  skipBadDiscount?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationPasswordAuthorizationArgs = {
  captcha: PowInput;
  password: Scalars['String']['input'];
  phoneId?: InputMaybe<Scalars['String']['input']>;
  userInfo?: InputMaybe<UserInfo>;
  username: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationPhoneRegistrationArgs = {
  captcha: PowInput;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneId?: InputMaybe<Scalars['String']['input']>;
  userInfo?: InputMaybe<UserInfo>;
  userToken?: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationPhoneVerificationArgs = {
  verificationCode?: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationProductComplaintArgs = {
  complaintText: Scalars['String']['input'];
  complaintType: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  productId: Scalars['Int']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationPromUserCreateUserArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationPromUserSendSmsArgs = {
  phoneNumber: Scalars['String']['input'];
  signature: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationPromUserVerifyPhoneArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  smsCode: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationPromoteProductFromBalanceArgs = {
  productId: Scalars['Int']['input'];
  tariffId: Scalars['Int']['input'];
  useBonus?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationPromoteProductWithPackageFromBalanceArgs = {
  packageId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  useBonus?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationRemoveDialogImportantArgs = {
  dialogId: Scalars['Int']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationRemoveFromFavouritesArgs = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationRemoveFromFollowerArgs = {
  userId: Scalars['Int']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationRemovePromoActionForProductsArgs = {
  allProducts?: InputMaybe<Scalars['Boolean']['input']>;
  excludeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  includeIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  promoType: PromoActionTypeEnum;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationResendSmsArgs = {
  captcha: PowInput;
  phoneNumber?: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationResetPasswordSendSmsArgs = {
  captcha: PowInput;
  phoneNumber?: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationSendSmsArgs = {
  phoneNumber?: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationSocialAuthorizationArgs = {
  accessToken: Scalars['String']['input'];
  phoneId?: InputMaybe<Scalars['String']['input']>;
  service: AuthServices;
  userInfo?: InputMaybe<UserInfo>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationSocialRegistrationArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  phoneId?: InputMaybe<Scalars['String']['input']>;
  recaptchaToken?: InputMaybe<Scalars['String']['input']>;
  service: AuthServices;
  userInfo?: InputMaybe<UserInfo>;
  username: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationSuspendPotentialDealArgs = {
  threadId: Scalars['Int']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationTofuSyncEnableArgs = {
  digest: Scalars['String']['input'];
  tofuUserId: Scalars['Int']['input'];
  tofuUsername: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationUnauthorizedPhoneVerificationArgs = {
  userToken?: Scalars['String']['input'];
  verificationCode?: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationUnauthorizedSendSmsArgs = {
  captcha: PowInput;
  phoneNumber?: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationUnblockDialogArgs = {
  threadId: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationUpdateAutoRenewArgs = {
  autoRenew: Scalars['Boolean']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationUpdateProductStatusArgs = {
  productId: Scalars['Int']['input'];
  status?: InputMaybe<ProductStatus>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationUpdateWorkStatusArgs = {
  iAmWorking: Scalars['Boolean']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationUploadMessagePhotoArgs = {
  uploadFile: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationUploadPhotoArgs = {
  uploadFile: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationUploadUserPhotoArgs = {
  uploadFile: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationUserComplaintArgs = {
  complaintText: Scalars['String']['input'];
  complaintType: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationUserResetPasswordViaEmailArgs = {
  activationKey?: Scalars['String']['input'];
  confirmPassword?: Scalars['String']['input'];
  newPassword?: Scalars['String']['input'];
  phoneId?: InputMaybe<Scalars['String']['input']>;
  userInfo?: InputMaybe<UserInfo>;
};


/** A GraphQL schema for each kind of mutation. */
export type MutationUserResetPasswordViaPhoneArgs = {
  confirmPassword?: Scalars['String']['input'];
  newPassword?: Scalars['String']['input'];
  phoneId?: InputMaybe<Scalars['String']['input']>;
  userInfo?: InputMaybe<UserInfo>;
  userToken?: Scalars['String']['input'];
};


/** A GraphQL schema for each kind of mutation. */
export type MutationUserTagsSuggestsArgs = {
  text: Scalars['String']['input'];
};

export type Namespace = {
  __typename?: 'Namespace';
  /** Catalog namespace. Not provided for root catalog like clothes */
  enum?: Maybe<CatalogNamespaces>;
  /** namespace id */
  id: Scalars['Int']['output'];
  idGender?: Maybe<Scalars['String']['output']>;
  /** namespace human-readable identifier */
  idString: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
};

export type Notification = {
  __typename?: 'Notification';
  button: NotificationButton;
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated use idStr instead */
  id: Scalars['Int']['output'];
  idStr: Scalars['String']['output'];
  image?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['DateTime']['output']>;
  templateId: Scalars['String']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type NotificationButton = {
  __typename?: 'NotificationButton';
  link: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<NotificationEdge>>;
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Notification` and its cursor. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Notification>;
};

/** An enumeration. */
export enum NotificationPriority {
  HighPriority = 'HIGH_PRIORITY',
  LowPriority = 'LOW_PRIORITY'
}

export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  priority: NotificationPriority;
};

export enum OperationSourceEnum {
  Balance = 'BALANCE',
  Bonus = 'BONUS'
}

export type OrderType = {
  __typename?: 'OrderType';
  /** Can the user return this product */
  canBeReturned: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
};

/** Meta information about part of outfit. */
export type OutfitPoitType = {
  __typename?: 'OutfitPoitType';
  /** slug to the related dynamic collection */
  collectionSlug: Scalars['String']['output'];
  /** Internal id of an object */
  id: Scalars['String']['output'];
  /** X coordinate for point on the outfit's image (image_url) */
  x: Scalars['Int']['output'];
  /** Y coordinate for point on the outfit's image (image_url) */
  y: Scalars['Int']['output'];
};

/** Outfit/Look */
export type OutfitType = {
  __typename?: 'OutfitType';
  /** Text with long description about look */
  description?: Maybe<Scalars['String']['output']>;
  /** Internal id of an object */
  id: Scalars['String']['output'];
  /** author's nickname */
  imageAuthor?: Maybe<Scalars['String']['output']>;
  /** image url with current look */
  imageUrl: Scalars['String']['output'];
  /** List of points for current outfit. */
  points: Array<OutfitPoitType>;
  /** slug of an object */
  slug: Scalars['String']['output'];
  /** Title of current look */
  title: Scalars['String']['output'];
};

export type OutfitTypeConnection = {
  __typename?: 'OutfitTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<OutfitTypeEdge>>;
  pageInfo: PageInfo;
};

/** A Relay edge containing a `OutfitType` and its cursor. */
export type OutfitTypeEdge = {
  __typename?: 'OutfitTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<OutfitType>;
};

/**
 * The object for representation information that connected with promotion packages
 * which owner can to use for current product.
 */
export type PackagePromotionType = {
  __typename?: 'PackagePromotionType';
  /** The url to icon for the current promotion. */
  icon: Scalars['String']['output'];
  /** The title of promotion. */
  title: Scalars['String']['output'];
};

export type Page = {
  __typename?: 'Page';
  body?: Maybe<Scalars['String']['output']>;
  head?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
  /** feed items total count */
  total?: Maybe<Scalars['Int']['output']>;
};

export type PageTreeNode = {
  __typename?: 'PageTreeNode';
  children: Array<PageTreeNode>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Applies sale participation
 * for current user
 *
 * errors:
 *  - bad_discount - some products has bad discount.
 *   Payload field have min discount that suitable for all products
 */
export type ParticipateInSale = {
  __typename?: 'ParticipateInSale';
  /** Operation errors */
  errors?: Maybe<Array<GraphResponseError>>;
};

/**
 * This is the implementation of the way to authorize via login and password
 *
 * ### error_codes(field 'username'):
 *
 * * __max_length__ - Username length more than 254 characters
 *
 * ### error_codes(field '\__all\__'):
 *
 * * __invalid_login__ - wrong password or username
 *
 * * __authorization_requests_limit__ - too many requests
 *
 * * __inactive__ - User deleted
 */
export type PasswordAuthorization = {
  __typename?: 'PasswordAuthorization';
  authToken?: Maybe<Scalars['String']['output']>;
  /** Upload photo errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** Authorized user   */
  user?: Maybe<User>;
};

/** An enumeration. */
export enum PayStatusType {
  Failure = 'failure',
  Pending = 'pending',
  Success = 'success'
}

/**
 * Details for order
 * (same model as on basket plain orders)
 */
export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  /** Enum for identify, where client should preferable go after "thank you" page */
  button: ServicePaymentResultButton;
  /** Some sub-text for payment "thank you" page */
  description: Scalars['String']['output'];
  /** Icon to render on "thank you" page */
  icon: Scalars['String']['output'];
  paymentStatus: PayStatusType;
  /** Status of service payment */
  status: ServicePaymentStatus;
  /** Title for payment "thank you" page */
  title: Scalars['String']['output'];
};

export type PaymentFingerprint = {
  browserAcceptHeader: Scalars['String']['input'];
  browserColorDepth: Scalars['String']['input'];
  browserIpAddress?: InputMaybe<Scalars['String']['input']>;
  browserJavaEnabled: Scalars['String']['input'];
  browserLanguage: Scalars['String']['input'];
  browserScreenHeight: Scalars['String']['input'];
  browserScreenWidth: Scalars['String']['input'];
  browserTimeZone: Scalars['String']['input'];
  browserTimeZoneOffset: Scalars['String']['input'];
  browserUserAgent: Scalars['String']['input'];
};

/** User payment history */
export type PaymentTransaction = {
  __typename?: 'PaymentTransaction';
  /**
   * Transaction amount DEPRECATED
   * @deprecated Use full_amount
   */
  amount: Scalars['Int']['output'];
  /** Balance after transaction */
  balance: Scalars['Float']['output'];
  /** Bonus balance after transaction */
  bonusBalance: Scalars['String']['output'];
  /** The user who buyed product */
  buyer?: Maybe<User>;
  /** Transaction creation datetime */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Transaction description */
  description?: Maybe<Scalars['String']['output']>;
  /** Transaction full amount */
  fullAmount: Scalars['String']['output'];
  /** An id payment transaction */
  id: Scalars['Int']['output'];
  operationSource: OperationSourceEnum;
  /** Transaction product */
  product?: Maybe<ProductDetails>;
  /** The is thread id where user buyed product */
  threadId?: Maybe<Scalars['Int']['output']>;
  /** Transaction type */
  type?: Maybe<Scalars['String']['output']>;
};

export type PaymentTransactionConnection = {
  __typename?: 'PaymentTransactionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentTransactionEdge>>;
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PaymentTransaction` and its cursor. */
export type PaymentTransactionEdge = {
  __typename?: 'PaymentTransactionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<PaymentTransaction>;
};

/**
 * Mutation for registration by phone
 *
 * ### error_codes(field 'username'):
 *
 * * __reg_username_illegal_chars__ - Username contains disallowed substring
 *  or bad first char or bad last char
 *
 * * __reg_username_is_tooshort__ - Too short
 *
 * * __reg_username_is_toolong__ - Too long
 *
 * * __reg_username_only_one_dot__ - Too many dots
 *
 * * __reg_username_toomuch_specchars__ - Too many special chars
 *
 * * __reg_username_contains_spaces__ - Username contains spaces
 *
 * * __reg_username_is_taken__ - Username already taken by another user
 *
 * ### error_codes(field 'email'):
 *
 * * __reg_email_invalid__ - Email is not valid
 *
 * ### error_codes(field '__all__'):
 *
 * * __reg_user_data_not_provided__ - Phone verification data not provided
 */
export type PhoneRegistration = {
  __typename?: 'PhoneRegistration';
  authToken?: Maybe<Scalars['String']['output']>;
  /** Upload photo errors */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** Signed user id used to login in shafa ua */
  signedUserId?: Maybe<Scalars['String']['output']>;
  /** Authorized user */
  user?: Maybe<User>;
};

/** Mutation for phone verification and save it */
export type PhoneVerification = {
  __typename?: 'PhoneVerification';
  /** Create product errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

/** Product photo object */
export type Photo = {
  __typename?: 'Photo';
  /** *id* of Product photo */
  id: Scalars['String']['output'];
  /** *id* of Product photo */
  idStr?: Maybe<Scalars['String']['output']>;
  /** *url* of Product origin photo */
  originalUrl: Scalars['String']['output'];
  /** *url* of Product thumbnail photo */
  thumbnailUrl: Scalars['String']['output'];
};

export type PlanType = {
  __typename?: 'PlanType';
  /** Bonus price. If bonus buy not available it equals to 0. */
  bonusPrice?: Maybe<Scalars['Decimal']['output']>;
  deliveryTariff: Array<DeliveryTariffType>;
  durationPeriods: Scalars['Int']['output'];
  freeShippingServices: Array<DeliveryServiceType>;
  frequencyType: FrequencyType;
  hasSellerCommission: Scalars['Boolean']['output'];
  /** @deprecated use planId */
  id?: Maybe<Scalars['Int']['output']>;
  isRecommend: Scalars['Boolean']['output'];
  minOrderPrice: Scalars['Int']['output'];
  /** Price without sale */
  oldPrice?: Maybe<Scalars['Decimal']['output']>;
  planId: Scalars['ID']['output'];
  price: Scalars['Decimal']['output'];
  /** has HTML tags */
  promoDescription?: Maybe<Scalars['String']['output']>;
  /** Real price added to bonus price. Use it when bonus price is > 0 */
  realPrice?: Maybe<Scalars['Decimal']['output']>;
  /** has HTML tags */
  secondPromoDescription?: Maybe<Scalars['String']['output']>;
  secondTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  totalPrice: Scalars['Decimal']['output'];
};

export type PopUpItem = {
  __typename?: 'PopUpItem';
  icon?: Maybe<Scalars['String']['output']>;
  markListItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PopularCatalog = {
  __typename?: 'PopularCatalog';
  countOfItems?: Maybe<Scalars['Int']['output']>;
  /** id* of Catalog */
  id: Scalars['Int']['output'];
  /** Mark catalog as adult only */
  isAdultOnly?: Maybe<Scalars['Boolean']['output']>;
  isAllowedPriceVariation: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use RootCatalog.namespaceInfo.image field instead */
  photo?: Maybe<Scalars['String']['output']>;
  /** Slug is unique so it uses instead of primary key   */
  slug: Scalars['String']['output'];
};

export type PosNegValue = {
  __typename?: 'PosNegValue';
  negative: Scalars['Int']['output'];
  positive: Scalars['Int']['output'];
};

export type PowInput = {
  nonce: Scalars['String']['input'];
  prefix: Scalars['String']['input'];
};

/** The class for represent the recommended price info. */
export type Price = {
  __typename?: 'Price';
  /** The recommended price */
  price?: Maybe<Scalars['String']['output']>;
};

/** A price filter type. Id can be used for filtering. */
export type PriceType = {
  __typename?: 'PriceType';
  /** filter id */
  id: Scalars['Int']['output'];
  /** filter name */
  name: Scalars['String']['output'];
  /** The minimum price for the goods */
  priceFrom?: Maybe<Scalars['Int']['output']>;
  /** The maximum price for the goods */
  priceTo?: Maybe<Scalars['Int']['output']>;
};

export type Product = {
  __typename?: 'Product';
  /** This is internal property, client not should use this property */
  Order?: Maybe<Scalars['String']['output']>;
  /** Absolute url of product */
  absoluteUrl?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Brand>;
  /**
   * Does buyer can leave seller rating
   * @deprecated User dialog.actions
   */
  buyerCanLeaveRating?: Maybe<Scalars['Boolean']['output']>;
  /** List of restrictions if delivery is cargo type */
  cargoRestrictions?: Maybe<Array<Maybe<CargoDeliveryRestriction>>>;
  /** Product *catalog* */
  catalog?: Maybe<RootCatalog>;
  catalogScore?: Maybe<CatalogScore>;
  /**
   * Slug of products catalog
   * @deprecated Use catalog field instead
   */
  catalogSlug?: Maybe<Scalars['String']['output']>;
  /**
   * *id* of city
   * @deprecated City object provided in cityObject field
   */
  city?: Maybe<Scalars['String']['output']>;
  /** The city of the current product   */
  cityObject?: Maybe<City>;
  /** *id* of color. For filtering you cat use 2 colors */
  color1?: Maybe<Scalars['String']['output']>;
  /** *id* of color. For filtering you cat use 2 colors */
  color2?: Maybe<Scalars['String']['output']>;
  /** *id* of condition */
  condition?: Maybe<Scalars['Int']['output']>;
  /** A date of created for current product */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** delivery services list of enums */
  deliveryServices?: Maybe<Array<DeliveryService>>;
  /** Product description */
  description?: Maybe<Scalars['String']['output']>;
  /** Show percent on which price decreased */
  discountPercent?: Maybe<Scalars['Int']['output']>;
  /** Extra fields, that are needed for marketing feeds */
  feedMeta?: Maybe<ProductFeedMeta>;
  /** lists of enums for which free delivery enabled */
  freeDeliveryServices?: Maybe<Array<DeliveryService>>;
  /** true if free pushup available for product */
  freePushupAvailable: Scalars['Boolean']['output'];
  /**
   * Gender, for which product is suited
   * @deprecated Use catalog.namespaceInfo field instead
   */
  gender?: Maybe<Scalars['String']['output']>;
  /** *id* of Product */
  id: Scalars['Int']['output'];
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  /** if product_id include in user favourite list property return *True*. Client must have a header *HTTP_X_AUTH_TOKEN*   */
  isLiked: Scalars['Boolean']['output'];
  /** return true if product is new   */
  isNew: Scalars['Boolean']['output'];
  /** Count of orders more than the product count */
  isOutOfStock: Scalars['Boolean']['output'];
  /** Return true if logged user are owner of current product. */
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  /** is owner of product working now */
  isOwnerWorking?: Maybe<Scalars['Boolean']['output']>;
  /** is product in processing multiple action   */
  isProcessingMultipleAction: ProductMultipleActionStatus;
  /** Identified, if product can be returned */
  isReturnEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** return true if product has status top   */
  isTop: Scalars['Boolean']['output'];
  /** is product made in ukraine */
  isUkrainian: Scalars['Boolean']['output'];
  /** Whether user viewed this product before. Provided only if feed query contains lastViewedProductId value. */
  isViewed: Scalars['Boolean']['output'];
  /** return true if product has status vip   */
  isVip?: Maybe<Scalars['Boolean']['output']>;
  /** *likes* count of Product   */
  likes: Scalars['Int']['output'];
  /**
   * Material of product, used in feeds service
   * @deprecated Use FeedMeta.characteristics instead
   */
  material?: Maybe<Scalars['String']['output']>;
  middleResponseTime?: Maybe<MiddleResponseTime>;
  /** *name* of Product   */
  name: Scalars['String']['output'];
  /** *name* of Product UK version */
  nameUk?: Maybe<Scalars['String']['output']>;
  /**
   * Namespace info of product
   * @deprecated Use catalog.namespaceInfo field instead
   */
  namespace?: Maybe<Namespace>;
  /** next date when free pushup will be available */
  nextFreePushupAt?: Maybe<Scalars['Date']['output']>;
  /** *old price* of Product */
  oldPrice?: Maybe<Scalars['Float']['output']>;
  /** True if user visit site not so long ago. */
  ownerHasRecentActivity: Scalars['Boolean']['output'];
  /** List of Product photos obj   */
  photos?: Maybe<Array<Maybe<Photo>>>;
  /** *price* of Product   */
  price?: Maybe<Scalars['Float']['output']>;
  /** Price deviation from median price(-100 to 100). Negative value means price is lower. Positive value means price is higher. */
  priceDeviation?: Maybe<Scalars['Int']['output']>;
  priceVariants?: Maybe<Array<ProductVariantType>>;
  /** Promotion */
  promotion?: Maybe<FeedProductPromotion>;
  rating?: Maybe<Scalars['Float']['output']>;
  ratingAmount?: Maybe<Scalars['Int']['output']>;
  /** Product sale descriptive label */
  saleLabel: SaleLabel;
  /** Product *seller* */
  seller: User;
  /** Does user has positive review */
  sellerHasPositiveReview?: Maybe<Scalars['Boolean']['output']>;
  sellingCondition: SellingConditionEnum;
  /** *id* of size   */
  size?: Maybe<Scalars['String']['output']>;
  /** *sizes* list of Product   */
  sizes?: Maybe<Array<Size>>;
  /** Product status title   */
  statusTitle?: Maybe<ProductVisibleStatus>;
  /** The list of tags for product */
  tags: Array<TagsEnum>;
  /** *url* of product's thumbnail   */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Product url on web */
  url: Scalars['String']['output'];
  /** Product user status title   */
  userStatusTitle?: Maybe<ProductUserStatus>;
};


export type ProductPriceVariantsArgs = {
  priceFrom?: InputMaybe<Scalars['Int']['input']>;
  priceTo?: InputMaybe<Scalars['Int']['input']>;
  sizeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ProductCharacteristic = {
  __typename?: 'ProductCharacteristic';
  /** Product characteristic variants */
  choices: Array<ProductCharacteristicChoice>;
  /** Product characteristic description */
  description?: Maybe<Scalars['String']['output']>;
  excludeFromCompletionScale: Scalars['Boolean']['output'];
  /** Product characteristic icon */
  icon?: Maybe<Scalars['String']['output']>;
  /** Product characteristic id */
  id: Scalars['Int']['output'];
  isRequired: Scalars['Boolean']['output'];
  /** Maximum number of selecting choices */
  maxCountForSelect: Scalars['Int']['output'];
  /** Product characteristic title */
  title: Scalars['String']['output'];
};

export type ProductCharacteristicChoice = {
  __typename?: 'ProductCharacteristicChoice';
  /** Choice description */
  description?: Maybe<Scalars['String']['output']>;
  /** Choice icon */
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  isIndexed: Scalars['Boolean']['output'];
  /** Choice name */
  title: Scalars['String']['output'];
};


export type ProductCharacteristicChoiceIsIndexedArgs = {
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Mutation for product complaint creation
 * TODO: delete after protobuf drop
 */
export type ProductComplaint = {
  __typename?: 'ProductComplaint';
  /** Create product errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductDeclineReason = {
  __typename?: 'ProductDeclineReason';
  /** Internal admin comment of decline reason. */
  comment?: Maybe<Scalars['String']['output']>;
  /** Date, when product was declined */
  createdAt: Scalars['String']['output'];
  /** Decline reason id */
  id: Scalars['Int']['output'];
  /** Rules, that cause decline. */
  rules: Array<Rule>;
};

/** Product details info */
export type ProductDetails = {
  __typename?: 'ProductDetails';
  /** Show count of availability products. */
  availabilityCount: Scalars['Int']['output'];
  banner?: Maybe<MainSlide>;
  bonusbackInfo?: Maybe<BonusbackInfo>;
  /** Product *brand* */
  brand?: Maybe<Brand>;
  /**
   * Does buyer can leave seller rating
   * @deprecated User dialog.actions
   */
  buyerCanLeaveRating?: Maybe<Scalars['Boolean']['output']>;
  /** Is *True* if this product may be bought */
  canBeBought: Scalars['Boolean']['output'];
  /** Is *True* if user can edit a current product */
  canBeEdited?: Maybe<Scalars['Boolean']['output']>;
  /** Show if user can swap product */
  canBeExchanged: Scalars['Boolean']['output'];
  /** Is *True* if this product may be mark as sold */
  canMarkAsSold: Scalars['Boolean']['output'];
  /** List of restrictions if delivery is cargo type */
  cargoRestrictions?: Maybe<Array<Maybe<CargoDeliveryRestriction>>>;
  /** Product *catalog* */
  catalog?: Maybe<Catalog>;
  characteristics: Array<ProductCharacteristic>;
  /** *colors* list of Product */
  colors?: Maybe<Array<Maybe<Color>>>;
  /**
   * *composition* of Product
   * @deprecated Legacy logic, you don't need to use it
   */
  composition?: Maybe<Scalars['String']['output']>;
  /** Product *condition* */
  condition?: Maybe<Condition>;
  /** CPA promotion for current product */
  cpaPromotion?: Maybe<CpaPromotion>;
  /** Reason, why product were declined (null if not declined) */
  declineReason?: Maybe<ProductDeclineReason>;
  /**
   * *delivery* of Product
   * @deprecated Legacy logic, you don't need to use it
   */
  delivery?: Maybe<Scalars['String']['output']>;
  /** *description* of Product */
  description: Scalars['String']['output'];
  /** *description* of Product RU version */
  descriptionRu: Scalars['String']['output'];
  /** *description* of Product UK version */
  descriptionUk: Scalars['String']['output'];
  /** The id of existing dialog */
  dialogId?: Maybe<Scalars['Int']['output']>;
  /**
   * How many dialogs about this product
   * @deprecated Legacy logic, you don't need to use it
   */
  dialogsCount: Scalars['Int']['output'];
  /** Show percent on which price decreased */
  discountPercent?: Maybe<Scalars['Int']['output']>;
  /** lists of enums for which free delivery enabled */
  freeDeliveryServices?: Maybe<Array<DeliveryService>>;
  /** true if free pushup available for product */
  freePushupAvailable: Scalars['Boolean']['output'];
  /** GTIN id */
  gtin?: Maybe<Scalars['String']['output']>;
  /** check if product has big discount for provided price */
  hasBigDiscount: Scalars['Boolean']['output'];
  /** id* of Product */
  id: Scalars['Int']['output'];
  /** Count of product organic impressions */
  impressionsCount?: Maybe<Scalars['Int']['output']>;
  /** return true if product in price range */
  inPriceRange?: Maybe<Scalars['Boolean']['output']>;
  /** Show if user can add product for swap */
  isAvailableExchange: Scalars['Boolean']['output'];
  /** if product_id include in user favourite list property return *True*. Client must have a header *HTTP_X_AUTH_TOKEN* */
  isLiked: Scalars['Boolean']['output'];
  /** return true if product is new */
  isNew: Scalars['Boolean']['output'];
  /** Count of orders more than the product count */
  isOutOfStock: Scalars['Boolean']['output'];
  isOwner: Scalars['Boolean']['output'];
  /** Is product in processing multiple action */
  isProcessingMultipleAction?: Maybe<ProductMultipleActionStatus>;
  /** Is *True* if this product may be returned to seller */
  isReturnEnabled: Scalars['Boolean']['output'];
  /** Whether user have to confirm sale when mark it sold */
  isSaleConfirmationRequired: Scalars['Boolean']['output'];
  /** Is product catalog have sizes for edit, show only for owner */
  isSizeEditable?: Maybe<Scalars['Boolean']['output']>;
  /** Enable automatic translation from uk to ru */
  isUkToRuTranslationEnabled: Scalars['Boolean']['output'];
  /** is product made in ukraine */
  isUkrainian: Scalars['Boolean']['output'];
  /** List of user's tags for current product. */
  keyWords?: Maybe<Array<Scalars['String']['output']>>;
  /** *likes* count of Product */
  likes: Scalars['Int']['output'];
  /**
   * How much user need money to sell the product as CPA
   * @deprecated CPA deleted
   */
  missingCpaCommission: Scalars['Int']['output'];
  /** How much user need money to sell the product */
  missingSaleCommission: Scalars['Int']['output'];
  /** *name* of Product */
  name: Scalars['String']['output'];
  /** *name* of Product RU version */
  nameRu: Scalars['String']['output'];
  /** *name* of Product UK version */
  nameUk: Scalars['String']['output'];
  /** next date when free pushup will be available */
  nextFreePushupAt?: Maybe<Scalars['Date']['output']>;
  /** *oldPrice* of Product */
  oldPrice?: Maybe<Scalars['Float']['output']>;
  /**
   * *urls* of Product origin photos
   * @deprecated Use `photos { original_url }`
   */
  originPhotos?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Count of product paid impressions */
  paidImpressionsCount?: Maybe<Scalars['Int']['output']>;
  /** List of Product photos obj */
  photos: Array<Photo>;
  /**
   * The list of possible buyers for the current product.
   * @deprecated use resolve_threads (there is buyer field in thread) instead
   */
  possibleBuyers: Array<User>;
  /** *price* of Product */
  price?: Maybe<Scalars['Float']['output']>;
  priceVariants?: Maybe<Array<ProductVariantType>>;
  /** A count of available Products */
  productCount: Scalars['Int']['output'];
  /** The list of promo actions for the current product. */
  promoActions?: Maybe<Array<PromoAction>>;
  /** The list of promo packages for the current product. */
  promoPackages?: Maybe<Array<PromoPackageType>>;
  /** The list of promotions for the current product. */
  promotions?: Maybe<Array<Promotion>>;
  /** Product publish date, show only for owner */
  publishDate?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  ratingAmount?: Maybe<Scalars['Int']['output']>;
  /** Product reviews url */
  reviewsUrl: Scalars['String']['output'];
  /** Product sale descriptive label */
  saleLabel: SaleLabel;
  /** Product *seller* */
  seller: User;
  sellingCondition: SellingConditionEnum;
  /** *sizes* list of Product */
  sizes: Array<Size>;
  /** Product *status* */
  status?: Maybe<Status>;
  /** Product status title */
  statusTitle?: Maybe<ProductVisibleStatus>;
  /** List of tags for this product */
  tags: Array<TagsEnum>;
  /** List of threads for this product */
  threads: Array<Thread>;
  /**
   * *urls* of Product thumbnails
   * @deprecated Use `photos { thumbnail_url }`
   */
  thumbnails?: Maybe<Array<Scalars['String']['output']>>;
  /** Product self url */
  url: Scalars['String']['output'];
  /** Brand created by user */
  userBrand?: Maybe<UserBrandType>;
  /** Product user status title */
  userStatusTitle: ProductUserStatus;
  /** The id of youtube video for iframe. */
  videoOverviewId?: Maybe<Scalars['String']['output']>;
  /** Count of product views by users(not owner) */
  viewsCount?: Maybe<Scalars['Int']['output']>;
  /** Product *visibility* */
  visibility?: Maybe<Visibility>;
  /** If owner has enabled safe payment method */
  withSafePayment: Scalars['Boolean']['output'];
};


/** Product details info */
export type ProductDetailsBannerArgs = {
  forMobileApps?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Product details info */
export type ProductDetailsHasBigDiscountArgs = {
  newPrice?: InputMaybe<Scalars['String']['input']>;
  priceVariantId?: InputMaybe<Scalars['String']['input']>;
};


/** Product details info */
export type ProductDetailsIsSaleConfirmationRequiredArgs = {
  buyerId: Scalars['Int']['input'];
};


/** Product details info */
export type ProductDetailsPromotionsArgs = {
  onlyDefaultPromotions?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Product details info */
export type ProductDetailsThreadsArgs = {
  isPbr?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductDetailsConnection = {
  __typename?: 'ProductDetailsConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductDetailsEdge>>;
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductDetails` and its cursor. */
export type ProductDetailsEdge = {
  __typename?: 'ProductDetailsEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProductDetailsProducts>;
};

export type ProductDetailsProducts = {
  __typename?: 'ProductDetailsProducts';
  /** This is internal property, client not should use this property */
  Order?: Maybe<Scalars['String']['output']>;
  /** Absolute url of product */
  absoluteUrl?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Brand>;
  /**
   * Does buyer can leave seller rating
   * @deprecated User dialog.actions
   */
  buyerCanLeaveRating?: Maybe<Scalars['Boolean']['output']>;
  /** List of restrictions if delivery is cargo type */
  cargoRestrictions?: Maybe<Array<Maybe<CargoDeliveryRestriction>>>;
  /** Product *catalog* */
  catalog?: Maybe<RootCatalog>;
  catalogScore?: Maybe<CatalogScore>;
  /**
   * Slug of products catalog
   * @deprecated Use catalog field instead
   */
  catalogSlug?: Maybe<Scalars['String']['output']>;
  /**
   * *id* of city
   * @deprecated City object provided in cityObject field
   */
  city?: Maybe<Scalars['String']['output']>;
  /** The city of the current product   */
  cityObject?: Maybe<City>;
  /** *id* of color. For filtering you cat use 2 colors */
  color1?: Maybe<Scalars['String']['output']>;
  /** *id* of color. For filtering you cat use 2 colors */
  color2?: Maybe<Scalars['String']['output']>;
  /** *id* of condition */
  condition?: Maybe<Scalars['Int']['output']>;
  /** A date of created for current product */
  createdAt?: Maybe<Scalars['String']['output']>;
  /** delivery services list of enums */
  deliveryServices?: Maybe<Array<DeliveryService>>;
  /** Product description */
  description?: Maybe<Scalars['String']['output']>;
  /** Show percent on which price decreased */
  discountPercent?: Maybe<Scalars['Int']['output']>;
  /** Extra fields, that are needed for marketing feeds */
  feedMeta?: Maybe<ProductFeedMeta>;
  /** lists of enums for which free delivery enabled */
  freeDeliveryServices?: Maybe<Array<DeliveryService>>;
  /** true if free pushup available for product */
  freePushupAvailable: Scalars['Boolean']['output'];
  /**
   * Gender, for which product is suited
   * @deprecated Use catalog.namespaceInfo field instead
   */
  gender?: Maybe<Scalars['String']['output']>;
  /** *id* of Product */
  id: Scalars['Int']['output'];
  isInternal?: Maybe<Scalars['Boolean']['output']>;
  /** if product_id include in user favourite list property return *True*. Client must have a header *HTTP_X_AUTH_TOKEN*   */
  isLiked: Scalars['Boolean']['output'];
  /** return true if product is new   */
  isNew: Scalars['Boolean']['output'];
  /** Count of orders more than the product count */
  isOutOfStock: Scalars['Boolean']['output'];
  /** Return true if logged user are owner of current product. */
  isOwner?: Maybe<Scalars['Boolean']['output']>;
  /** is owner of product working now */
  isOwnerWorking?: Maybe<Scalars['Boolean']['output']>;
  /** is product in processing multiple action   */
  isProcessingMultipleAction: ProductMultipleActionStatus;
  /** Identified, if product can be returned */
  isReturnEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** return true if product has status top   */
  isTop: Scalars['Boolean']['output'];
  /** is product made in ukraine */
  isUkrainian: Scalars['Boolean']['output'];
  /** Whether user viewed this product before. Provided only if feed query contains lastViewedProductId value. */
  isViewed: Scalars['Boolean']['output'];
  /** return true if product has status vip   */
  isVip?: Maybe<Scalars['Boolean']['output']>;
  /** *likes* count of Product   */
  likes: Scalars['Int']['output'];
  /**
   * Material of product, used in feeds service
   * @deprecated Use FeedMeta.characteristics instead
   */
  material?: Maybe<Scalars['String']['output']>;
  middleResponseTime?: Maybe<MiddleResponseTime>;
  /** *name* of Product   */
  name: Scalars['String']['output'];
  /** *name* of Product UK version */
  nameUk?: Maybe<Scalars['String']['output']>;
  /**
   * Namespace info of product
   * @deprecated Use catalog.namespaceInfo field instead
   */
  namespace?: Maybe<Namespace>;
  /** next date when free pushup will be available */
  nextFreePushupAt?: Maybe<Scalars['Date']['output']>;
  /** *old price* of Product */
  oldPrice?: Maybe<Scalars['Float']['output']>;
  /** True if user visit site not so long ago. */
  ownerHasRecentActivity: Scalars['Boolean']['output'];
  /** List of Product photos obj   */
  photos?: Maybe<Array<Maybe<Photo>>>;
  /** *price* of Product   */
  price?: Maybe<Scalars['Float']['output']>;
  /** Price deviation from median price(-100 to 100). Negative value means price is lower. Positive value means price is higher. */
  priceDeviation?: Maybe<Scalars['Int']['output']>;
  priceVariants?: Maybe<Array<ProductVariantType>>;
  /** Promotion */
  promotion?: Maybe<FeedProductPromotion>;
  rating?: Maybe<Scalars['Float']['output']>;
  ratingAmount?: Maybe<Scalars['Int']['output']>;
  /** Product sale descriptive label */
  saleLabel: SaleLabel;
  /** Product *seller* */
  seller: User;
  /** Does user has positive review */
  sellerHasPositiveReview?: Maybe<Scalars['Boolean']['output']>;
  sellingCondition: SellingConditionEnum;
  /** *id* of size   */
  size?: Maybe<Scalars['String']['output']>;
  /** *sizes* list of Product   */
  sizes?: Maybe<Array<Size>>;
  /** Product status title   */
  statusTitle?: Maybe<ProductVisibleStatus>;
  /** The list of tags for product */
  tags: Array<TagsEnum>;
  /** *url* of product's thumbnail   */
  thumbnail?: Maybe<Scalars['String']['output']>;
  /** Product url on web */
  url: Scalars['String']['output'];
  /** Product user status title   */
  userStatusTitle?: Maybe<ProductUserStatus>;
};


export type ProductDetailsProductsPriceVariantsArgs = {
  priceFrom?: InputMaybe<Scalars['Int']['input']>;
  priceTo?: InputMaybe<Scalars['Int']['input']>;
  sizeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Extra fields, that are needed for marketing feeds */
export type ProductFeedMeta = {
  __typename?: 'ProductFeedMeta';
  /**
   * Absolute url for product
   * @deprecated use Product.absoluteUrl field instead
   */
  absoluteUrl?: Maybe<Scalars['String']['output']>;
  characteristics: Array<ProductCharacteristic>;
  /** All product colors in one string */
  colorsString?: Maybe<Scalars['String']['output']>;
  /** Product ctr rate */
  ctr?: Maybe<Scalars['Float']['output']>;
  /**
   * Full path for category in format like "Apparel & Accessories > Clothing > Dresses"
   * @deprecated Use catalog field instead
   */
  googleProductCategory?: Maybe<Scalars['String']['output']>;
  gtin?: Maybe<Scalars['String']['output']>;
  kvi?: Maybe<Scalars['Boolean']['output']>;
  messagesCount: Scalars['Int']['output'];
  productCount: Scalars['Int']['output'];
  productScore?: Maybe<Scalars['Float']['output']>;
  productSellerCount: Scalars['Int']['output'];
  /** Seller type from elastic (new, super_seller) */
  sellerType?: Maybe<Array<SellerTypeEnum>>;
  /** List of user's tags for current product. */
  userTags: Array<Scalars['String']['output']>;
  viewsCount: Scalars['Int']['output'];
};

export type ProductInput = {
  /** Additional product sizes ids */
  additionalSizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  /** Brand id */
  brand?: InputMaybe<Scalars['Int']['input']>;
  /** Additional product characteristics */
  characteristics?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** colors Enum */
  colors: Array<InputMaybe<ColorEnum>>;
  /** Condition Enum */
  condition: ConditionEnum;
  /** Count of available items of current product */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** Product delivery */
  delivery?: InputMaybe<Scalars['String']['input']>;
  /** Product description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Product consistency */
  description2?: InputMaybe<Scalars['String']['input']>;
  /** Product description RU version */
  descriptionRu?: InputMaybe<Scalars['String']['input']>;
  /** Product description UK version */
  descriptionUk?: InputMaybe<Scalars['String']['input']>;
  /** GTIN id */
  gtin?: InputMaybe<Scalars['String']['input']>;
  /** True if product made in Ukraine */
  isMadeInUkraine?: InputMaybe<Scalars['Boolean']['input']>;
  /** True if user added self made image to product */
  isSelfMadeImageAdded?: InputMaybe<Scalars['Boolean']['input']>;
  /** Bool accept terms */
  isTermsAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Enable automatic translation from uk to ru */
  isUkToRuTranslationEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The list of keywords for current product. */
  keyWords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Product title */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Product title UK version */
  nameRu?: InputMaybe<Scalars['String']['input']>;
  /** Product title UK version */
  nameUk?: InputMaybe<Scalars['String']['input']>;
  /** Photos id str */
  photosStr?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Product price */
  price?: InputMaybe<Scalars['Int']['input']>;
  /** Additional product price variants */
  priceVariants?: InputMaybe<Array<CreatePriceVariantType>>;
  /** Promotion type Enum */
  promotionType?: InputMaybe<PromotionTypeEnum>;
  /** Selling condition Enum */
  sellingCondition: SellingConditionEnum;
  /** Size id */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** Id on UserBrand */
  userBrand?: InputMaybe<Scalars['Int']['input']>;
  /** Link to youtube about overview current product. */
  videoOverview?: InputMaybe<Scalars['String']['input']>;
};

export enum ProductMultipleActionStatus {
  Activating = 'ACTIVATING',
  Deactivating = 'DEACTIVATING',
  Default = 'DEFAULT'
}

/** An enumeration. */
export enum ProductPaginationType {
  Cursor = 'CURSOR',
  Page = 'PAGE'
}

export enum ProductPromotionTypeEnum {
  Cpa = 'CPA',
  Package = 'PACKAGE',
  PushUp = 'PUSH_UP',
  Top = 'TOP',
  Vip = 'VIP'
}

export type ProductReviewConnection = {
  __typename?: 'ProductReviewConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProductReviewEdge>>;
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProductReview` and its cursor. */
export type ProductReviewEdge = {
  __typename?: 'ProductReviewEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProductReviewType>;
};

export type ProductReviewForm = {
  __typename?: 'ProductReviewForm';
  expireDate: Scalars['Date']['output'];
  form: Array<ReviewQuestionBlock>;
  productId: Scalars['Int']['output'];
};

export type ProductReviewType = {
  __typename?: 'ProductReviewType';
  createdAt: Scalars['Date']['output'];
  id: Scalars['Int']['output'];
  overallRating: Scalars['Int']['output'];
  photos?: Maybe<Array<Photo>>;
  product: ProductDetails;
  text?: Maybe<Scalars['String']['output']>;
  /** Review owner */
  user: User;
};

/** An enumeration. */
export enum ProductSaleStatus {
  SaleNone = 'SALE_NONE',
  SaleNotStarted = 'SALE_NOT_STARTED',
  SaleStarted = 'SALE_STARTED'
}

/**
 * The object representation data connected with type of products as active,
 * pinned etc. This information is using for dynamic getting all possible
 * filters for profile feed's related with state of product.
 */
export type ProductStateFilter = {
  __typename?: 'ProductStateFilter';
  /** The count of products which have this current status. */
  count: Scalars['Int']['output'];
  state: ProfileProductTypeEnum;
  /** The name of filer state. */
  text: Scalars['String']['output'];
};

export enum ProductStatus {
  Reserved = 'RESERVED',
  Visible = 'VISIBLE'
}

export enum ProductUserStatus {
  Default = 'DEFAULT',
  Hidden = 'HIDDEN'
}

export type ProductVariantType = {
  __typename?: 'ProductVariantType';
  bonusbackInfo?: Maybe<BonusbackInfo>;
  /** Show percent on which price decreased */
  discountPercent?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** old price */
  oldPrice?: Maybe<Scalars['MoneyType']['output']>;
  /** Price of the variant */
  price: Scalars['MoneyType']['output'];
  /** Product sale descriptive label */
  saleLabel: SaleLabel;
  size: Size;
};

/** An enumeration. */
export enum ProductViewSource {
  Catalog = 'catalog',
  Collection = 'collection'
}

export enum ProductVisibleStatus {
  Available = 'AVAILABLE',
  Declined = 'DECLINED',
  Deleted = 'DELETED',
  ModerationRequired = 'MODERATION_REQUIRED',
  Reserved = 'RESERVED',
  Sold = 'SOLD'
}

export enum ProfileProductTypeEnum {
  Active = 'ACTIVE',
  Declined = 'DECLINED',
  Deleted = 'DELETED',
  Inactive = 'INACTIVE',
  Moderated = 'MODERATED',
  Pinned = 'PINNED',
  Promoted = 'PROMOTED',
  Reserved = 'RESERVED',
  Sold = 'SOLD'
}

/**
 * Create user by login and phone number
 *
 * ### error_codes(field 'username'):
 *
 * * __reg_username_illegal_chars__ - Username contains disallowed substring
 *  or bad first char or bad last char
 *
 * * __reg_username_is_tooshort__ - Too short
 *
 * * __reg_username_is_toolong__ - Too long
 *
 * * __reg_username_only_one_dot__ - Too many dots
 *
 * * __reg_username_toomuch_specchars__ - Too many special chars
 *
 * * __reg_username_contains_spaces__ - Username contains spaces
 *
 * * __reg_username_is_taken__ - Username already taken by another user
 *
 * ### error_codes(field '__all__'):
 *
 * * __phone_does_not_verified__ - Phone does not verified
 * * __already_used__ - Phone already in use
 */
export type PromImportRegistration = {
  __typename?: 'PromImportRegistration';
  errors: Array<GraphResponseError>;
  /** Created user */
  user?: Maybe<User>;
};

/**
 * If phone number exist, mutation will return user_id of phone owner and account will
 * be verified, else mutation will return None
 *
 * ### error_codes(field `__all__`):
 * * __sms_does_not_sent__ - Sms does not send or data expired
 * * __attempt_reached__ - User reached attempt of enter code reached
 * * __code_invalid__ - Verification code is invalid
 */
export type PromImportSmsCodeVerification = {
  __typename?: 'PromImportSmsCodeVerification';
  errors: Array<GraphResponseError>;
  /** Created user */
  user?: Maybe<User>;
};

/**
 * Send sms on phone number
 *
 * ### error_codes(field `__all__`):
 * * __too_many_requests__ - To many request for send sms. 3 sms/10 min
 * * __invalid__ - Invalid phone number
 *
 * ### error_codes(field 'signature'):
 * * __invalid__ - invalid signature
 */
export type PromSendSmsMutation = {
  __typename?: 'PromSendSmsMutation';
  errors: Array<GraphResponseError>;
  /** User token for phone identification */
  key?: Maybe<Scalars['String']['output']>;
};

/** Promo action */
export type PromoAction = {
  __typename?: 'PromoAction';
  /** Conditions of promo action */
  conditions: Array<PromoCondition>;
  /** Description of promo action */
  description: Scalars['String']['output'];
  /** Url of the icon for promo action */
  icon?: Maybe<Scalars['String']['output']>;
  /** Promo action type */
  id: PromoActionTypeEnum;
  /** Description for 'important'  */
  important?: Maybe<Scalars['String']['output']>;
  /** Is product added to current promo action */
  isAdded: Scalars['Boolean']['output'];
  /** description on the product details page */
  promoInfo?: Maybe<Scalars['String']['output']>;
  /** Promo action type */
  promoType: PromoActionTypeEnum;
  /** Selected condition */
  selectedCondition?: Maybe<PromoCondition>;
  /** Title of promo action */
  title: Scalars['String']['output'];
};

/**
 * Promo action enum
 *     - FREE_SHIPPING
 */
export enum PromoActionTypeEnum {
  FreeShipping = 'FREE_SHIPPING'
}

export type PromoCondition = {
  __typename?: 'PromoCondition';
  /** Is condition selected for current promo */
  isSelected: Scalars['Boolean']['output'];
  /** Type of condition */
  type: PromoConditionType;
  /** Value of condition for promo action */
  value?: Maybe<Scalars['String']['output']>;
};

export type PromoConditionInput = {
  /** Type of condition */
  type: PromoConditionType;
  /** Value of condition */
  value?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Condition of promo action
 * - EMPTY - in a case when condition not provided
 * - FROM_ITEM - in a case when condition depends on total item
 * - FROM_PRICE - in a case when condition depends on total amount
 */
export enum PromoConditionType {
  Empty = 'EMPTY',
  FromItem = 'FROM_ITEM',
  FromPrice = 'FROM_PRICE'
}

/** Information about promotion pacakge on product from feed */
export type PromoPackageType = {
  __typename?: 'PromoPackageType';
  /** Package price for bonus buying */
  bonusPrice?: Maybe<Scalars['MoneyType']['output']>;
  /** Description of the promo package */
  description?: Maybe<Scalars['String']['output']>;
  /** Discount value (int from 1 to 100) */
  discount?: Maybe<Scalars['Int']['output']>;
  /** Id of promo package */
  id: Scalars['Int']['output'];
  /** Shows if this package should be opened by default in UI */
  isOpenedByDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the promo package */
  label: Scalars['String']['output'];
  /** Package price without discount */
  originalPrice: Scalars['MoneyType']['output'];
  /** Package price with discount */
  price: Scalars['MoneyType']['output'];
  /** List of promotions in package */
  promotions?: Maybe<Array<Maybe<PackagePromotionType>>>;
  /** Unique lowercase ascii name of promo package */
  slug?: Maybe<Scalars['String']['output']>;
};

/** This is the implementation of promoting the product from user balance */
export type PromoteProductMutation = {
  __typename?: 'PromoteProductMutation';
  /** Promote products error */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

/** This is the implementation of promoting the product from user balance */
export type PromoteProductWithPromoPackageMutation = {
  __typename?: 'PromoteProductWithPromoPackageMutation';
  /** Promote products error */
  errors?: Maybe<Array<GraphResponseError>>;
};

/**
 * The object for representation information that connected with promotions
 * which owner can to use for current product.
 */
export type Promotion = {
  __typename?: 'Promotion';
  /** The list of advantages of current promotion. */
  advantages: Array<Advantage>;
  /** It's `True` if a product can be promoted by the current promotion. */
  canBePromoted: Scalars['Boolean']['output'];
  /** Card mask for default card */
  cardMask?: Maybe<Scalars['String']['output']>;
  /** The short description of the current promotion. */
  description: Scalars['String']['output'];
  /** The url to icon for the current promotion. */
  icon: Scalars['String']['output'];
  /** Info about promotion such as icon, description etc */
  promotionInfo: PromotionInfo;
  /** name of the promotion */
  promotionName: Scalars['String']['output'];
  /** The reason why product can't be promoted by current promotion. */
  reason?: Maybe<Scalars['String']['output']>;
  /** The list of possibility tariffs for the current promotion. */
  tariffs?: Maybe<Array<Tariff>>;
  /** The title of promotion. */
  title: Scalars['String']['output'];
};

/**
 * The object that stores info about promotion such as icons
 * for desktop, description etc
 */
export type PromotionInfo = {
  __typename?: 'PromotionInfo';
  /** info about promotion desktop */
  about: Scalars['String']['output'];
  /** full info about promotion desktop */
  aboutText: Scalars['String']['output'];
  /** url for example of such promotion */
  exampleUrl?: Maybe<Scalars['String']['output']>;
  /** icon for desktop */
  icon: Scalars['String']['output'];
  /** main promotion advantage desktop */
  mainAdvantage?: Maybe<Scalars['String']['output']>;
  /** label of the payment button for current promotion desktop */
  paymentLabel: Scalars['String']['output'];
};

export enum PromotionTypeEnum {
  CpaPromotion = 'CPA_PROMOTION',
  NoPromotion = 'NO_PROMOTION',
  Promote = 'PROMOTE'
}

/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type Query = {
  __typename?: 'Query';
  activeSales?: Maybe<SaleConnection>;
  catalog?: Maybe<RootCatalog>;
  /** params which use for calculate total_score */
  catalogScoreParams?: Maybe<CatalogScoreParams>;
  catalogTree?: Maybe<CatalogTree>;
  city: City;
  collection?: Maybe<CollectionType>;
  complaintTypes?: Maybe<ComplaintTypesResponse>;
  confirmedPotentialDealDialogs?: Maybe<ThreadConnection>;
  dynamicCollection: DynamicCollection;
  dynamicCollectionCustom: DynamicCollectionCustom;
  /** return maximum of ten brands that have similar name */
  filterBrand: Array<Brand>;
  /** Return list of all cities */
  filterCity?: Maybe<Array<City>>;
  filterColors?: Maybe<Array<ColorType>>;
  filterCondition: Array<ConditionType>;
  filterPrice?: Maybe<Array<PriceType>>;
  /** For get list of sizes for some catalog need `catalog_id`, if param is absent or incorrect return null */
  filterSize?: Maybe<Array<SizeType>>;
  /** Return list of all possible variants of sorting */
  filterSorting?: Maybe<Array<Maybe<SortType>>>;
  /** return up to 500 brands, first 10 in products count order, other 490 in alphabetical order */
  filterTopBrands: TopBrands;
  /** The list of products for index suggestion block */
  indexSuggestions: DynamicCollection;
  /** Fraud info */
  isFraudData: FraudInfo;
  /** Current logo */
  logo: LogoImage;
  mainBanner: MainSlider;
  newProducts?: Maybe<FeedConnection>;
  /** List of all not ended sales */
  notEndedSales: Array<GraphSale>;
  /** List of all not started sales */
  notStartedSales: Array<GraphSale>;
  notification?: Maybe<Notification>;
  outfit: OutfitType;
  /** List of outfit collections */
  outfits?: Maybe<OutfitTypeConnection>;
  page?: Maybe<Page>;
  pagesTree: Array<PageTreeNode>;
  popularCatalogs?: Maybe<Array<Maybe<PopularCatalog>>>;
  /** Threads with potentially sold products */
  potentialDealDialogs?: Maybe<Array<Thread>>;
  /** @deprecated Use `complainTypes instead` since user and product complaints are the same */
  productComplaintTypes?: Maybe<ComplaintTypesResponse>;
  productDetails: ProductDetails;
  /**
   *
   *     Return list of other owner products for product details page.
   *
   *     By default return only 5 items. For get more products use
   *     param PerPage.
   *
   *     Note: can't return more than 10 items:  if perPage > 10 -> perPage=10
   *
   */
  productDetailsOwnerProducts?: Maybe<Array<Maybe<ProductDetailsProducts>>>;
  /**
   *
   *     Return list of similar products for product details page.
   *
   *     By default return only 5 items. For get more products use
   *     param PerPage.
   *
   *     Note: can't return more than 10 items:  if perPage > 10 -> perPage=10
   *
   */
  productDetailsSimilarPaginateProducts?: Maybe<ProductDetailsConnection>;
  /**
   *
   *     Return list of similar products for product details page.
   *
   *     By default return only 5 items. For get more products use
   *     param PerPage.
   *
   *     Note: can't return more than 10 items:  if perPage > 10 -> perPage=10
   *
   */
  productDetailsSimilarProducts?: Maybe<Array<Maybe<ProductDetailsProducts>>>;
  /**
   *
   *     Return list of promoted products for product details page.
   *
   *     By default return only 5 items. For get more products use
   *     param PerPage.
   *
   *     Note: can't return more than 10 items:  if perPage > 10 -> perPage=10
   *
   */
  productDetailsTopProducts?: Maybe<Array<Maybe<ProductDetailsProducts>>>;
  productReviews?: Maybe<ProductReviewConnection>;
  /**
   *
   *     Return list of products for some catalog, by default return
   *     products form women catalog.
   *
   *     By default return only first 10 items. For get other products using
   *     pagination.
   *
   *     {
   *       products(first: 10) {
   *         edges {
   *           node {
   *             id
   *           }
   *           cursor # not necessary
   *         }
   *         pageInfo {
   *           hasNextPage
   *           hasPreviousPage
   *           startCursor
   *           endCursor
   *           total
   *         }
   *       }
   *     }
   *
   *     If you want get next page, test if hasNextPage is True and next
   *     using some code like bellow:
   *
   *
   *     {
   *       products(first: 10, after: `your previous endCursor value`) {
   *         edges {
   *           node {
   *             id
   *           }
   *         }
   *         pageInfo {
   *           hasNextPage
   *           hasPreviousPage
   *           startCursor
   *           endCursor
   *           total
   *         }
   *       }
   *     }
   *
   */
  products?: Maybe<FeedConnection>;
  /** The list of promo actions. */
  promoActions?: Maybe<Array<PromoAction>>;
  /**
   *
   *             The class represent data connected with recommended price for some
   *             catalog with some special condition. You also can specify price for
   *             some brand, but it's optional.
   *
   */
  recommendedPrice?: Maybe<Price>;
  /** Return all params that need for send refill request to the wfp. */
  refillBalanceParams?: Maybe<BalancePayment>;
  region: Region;
  rootCatalogs: Array<Catalog>;
  /** Returns specified sale data */
  sale: GraphSale;
  savedSearch: SavedSearch;
  /** *id* for current catalog_url */
  searchSubscribeId?: Maybe<Scalars['String']['output']>;
  sellProductTextInfo?: Maybe<Scalars['String']['output']>;
  seoTag: SeoTag;
  seoTagProducts?: Maybe<FeedSeoTagProductConnection>;
  /** Smart subscription info */
  smartInfo: SubscriptionInfo;
  staticFlags: StaticFlags;
  swapCollection?: Maybe<DynamicCollectionCustom>;
  /**
   * Required info to enable tofu sync
   * @deprecated Dont used
   */
  tofuDigestData: TofuDigestData;
  /**
   * Required info to crete tofu sync button component
   * @deprecated Dont used
   */
  tofuSyncButtonData: TofuSyncButtonData;
  /** top Products per page */
  topProducts: Array<Product>;
  /** top Products per page */
  topProductsV2: FeedConnection;
  topSellerProducts?: Maybe<FeedConnection>;
  /** The user by given id. */
  user?: Maybe<User>;
  /** @deprecated Use `complainTypes instead` since user and product complaints are the same */
  userComplaintTypes?: Maybe<ComplaintTypesResponse>;
  /** The current authenticated user. */
  viewer: User;
  /**
   * Badge with count of sales available for user participation
   * @deprecated Dont use
   */
  viewerAvailableSalesCount: Scalars['String']['output'];
  vipProducts?: Maybe<FeedConnection>;
  virtualCatalog: VirtualCatalog;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryActiveSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryCatalogArgs = {
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryCityArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryCollectionArgs = {
  collectionId: CollectionsEnum;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryComplaintTypesArgs = {
  complaintId?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryConfirmedPotentialDealDialogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryDynamicCollectionArgs = {
  collectionSlug?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryDynamicCollectionCustomArgs = {
  collectionSlug?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryFilterBrandArgs = {
  excludeIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryFilterSizeArgs = {
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  sizeGroup?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryFilterTopBrandsArgs = {
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  dynamicCollectionSlug?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryNewProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brands?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  characteristics?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  priceFrom?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priceTo?: InputMaybe<Scalars['Int']['input']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ukrainian?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryNotificationArgs = {
  notificationId?: InputMaybe<Scalars['Int']['input']>;
  notificationIdStr?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryOutfitArgs = {
  slug: Scalars['String']['input'];
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryOutfitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryPageArgs = {
  slug: Scalars['String']['input'];
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryProductComplaintTypesArgs = {
  complaintUserId?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryProductDetailsArgs = {
  fromAdv?: InputMaybe<Scalars['Boolean']['input']>;
  incrViews?: InputMaybe<Scalars['Boolean']['input']>;
  productId: Scalars['Int']['input'];
  source?: InputMaybe<ProductViewSource>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryProductDetailsOwnerProductsArgs = {
  perPage?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryProductDetailsSimilarPaginateProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryProductDetailsSimilarProductsArgs = {
  perPage?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryProductDetailsTopProductsArgs = {
  perPage?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryProductReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  productId: Scalars['Int']['input'];
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brands?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  characteristics?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  collectionId?: InputMaybe<Scalars['Int']['input']>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  indexedFilter?: InputMaybe<IndexedFilterInput>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  isSearchMostFrequentCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastViewedProductId?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  priceFrom?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priceTo?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  timestamp?: InputMaybe<Scalars['Int']['input']>;
  ukrainian?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryRecommendedPriceArgs = {
  brand?: InputMaybe<Scalars['Int']['input']>;
  catalog: Scalars['String']['input'];
  condition: ConditionEnum;
  size?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QuerySaleArgs = {
  id: Scalars['Int']['input'];
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QuerySavedSearchArgs = {
  id: Scalars['Int']['input'];
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QuerySearchSubscribeIdArgs = {
  catalogUrl: Scalars['String']['input'];
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QuerySellProductTextInfoArgs = {
  threadId: Scalars['Int']['input'];
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QuerySeoTagArgs = {
  slug?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QuerySeoTagProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brands?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  characteristics?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  isSearchMostFrequentCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  priceFrom?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priceTo?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  seoTagSlug?: InputMaybe<Scalars['String']['input']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ukrainian?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryTofuDigestDataArgs = {
  shafaDigest?: InputMaybe<Scalars['String']['input']>;
  tofuUserId?: InputMaybe<Scalars['Int']['input']>;
  tofuUsername?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryTopProductsArgs = {
  brands?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  characteristics?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  priceFrom?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priceTo?: InputMaybe<Scalars['Int']['input']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ukrainian?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryTopProductsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brands?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  characteristics?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dynamicCollectionSlug?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  paginationType?: InputMaybe<ProductPaginationType>;
  priceFrom?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priceTo?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ukrainian?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryTopSellerProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brands?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  characteristics?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  priceFrom?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priceTo?: InputMaybe<Scalars['Int']['input']>;
  productId?: InputMaybe<Scalars['Int']['input']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ukrainian?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryUserArgs = {
  id?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryUserComplaintTypesArgs = {
  complaintUserId?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryVipProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  random?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A GraphQL schema provides a root type for each kind of operation.
 *
 * - resolvers for list of filters/sorts start with of **filter**.
 * - the **products** resolver return feed of products
 */
export type QueryVirtualCatalogArgs = {
  slug: Scalars['String']['input'];
};

/**
 *
 *     Enum with types of question, that can be in seller rating poll.
 *     Each enum value is mapped to some aggregation on backend,
 *     and rendering on client side
 *
 */
export enum QuestionType {
  TypeOverallRating = 'TYPE_OVERALL_RATING',
  TypePhotos = 'TYPE_PHOTOS',
  TypeRating = 'TYPE_RATING',
  TypeTextArea = 'TYPE_TEXT_AREA',
  TypeTextChoice = 'TYPE_TEXT_CHOICE',
  TypeThumbUpDown = 'TYPE_THUMB_UP_DOWN'
}

export type RatingValue = {
  __typename?: 'RatingValue';
  value: Scalars['String']['output'];
};

/**
 *
 *     Enum, that holds rating star name
 *     Value = numerical equivalent for star
 *
 */
export enum RatingValues {
  Rating_1Star = 'RATING_1_STAR',
  Rating_2Star = 'RATING_2_STAR',
  Rating_3Star = 'RATING_3_STAR',
  Rating_4Star = 'RATING_4_STAR',
  Rating_5Star = 'RATING_5_STAR'
}

export type ReferralProgramInfo = {
  __typename?: 'ReferralProgramInfo';
  /** Max amount of user referrals */
  maxReferralsCount: Scalars['Int']['output'];
  /** How much both users earn if referral program conditions will be completed */
  referralProgramReward: Scalars['Int']['output'];
  /** Link for referrals */
  referralUrl: Scalars['String']['output'];
  /** Number of user referrals who already completed referral program conditions */
  referralsCount: Scalars['Int']['output'];
};

/** Used to represent region related features */
export type Region = {
  __typename?: 'Region';
  currencyFullName: Scalars['String']['output'];
  currencyName: Scalars['String']['output'];
  /** Shafa business region id */
  id: Scalars['String']['output'];
  /** Regexp that check whether phone valid or not */
  phoneCheckRegexp: Scalars['String']['output'];
  phoneCode: Scalars['String']['output'];
  /** Phone length without code */
  phoneLength: Scalars['Int']['output'];
  /** Phone max length (with code) */
  phoneMaxLength: Scalars['Int']['output'];
};

/** The mutation remove important status of dialog for current user. */
export type RemoveDialogImportant = {
  __typename?: 'RemoveDialogImportant';
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * This is the implementation of the way to remove products from the user's
 * favorites. If products exist in favourites for current user it remove them,
 * else do nothing.
 */
export type RemoveFavourites = {
  __typename?: 'RemoveFavourites';
  isSuccess: Scalars['Boolean']['output'];
};

/**
 * This is the implementation of removing promo for the product
 *
 * **Before adding/removing a product, make sure that promotion is created**
 *
 * Error codes:
 *     - promo_action_not_created - Promo action is not created
 *     - already_adding_removing - task for removing product to promo action
 *       already created
 *     - one_of_error - invalid params for mutation(required on of includeIds,
 *       excludeIds, allProducts)
 *     - params_both_error - invalid params, too many params, only 1 required
 */
export type RemovePromoMutation = {
  __typename?: 'RemovePromoMutation';
  /** Promote products error */
  errors?: Maybe<Array<GraphResponseError>>;
};

/**
 * This is the implementation of the way to remove user from follower list for
 * the current user.
 */
export type RemoveToFollower = {
  __typename?: 'RemoveToFollower';
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
};

/** This mutation send email with link for restore password */
export type ResetPassword = {
  __typename?: 'ResetPassword';
  /** Reset password errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Mutation for send sms password recovery
 *
 * ### error_codes(field 'phone_number'):
 * * __invalid__ - Bad phone format
 * * __is_not_used__ - Phone is not use
 *
 * ### error_codes(field '__all__'):
 * * __too_many_requests__ - User send too much sms
 */
export type ResetPasswordSendSms = {
  __typename?: 'ResetPasswordSendSMS';
  /** Create product errors */
  errors?: Maybe<Array<GraphResponseError>>;
  /** @deprecated watch on errors filed */
  isSuccess: Scalars['Boolean']['output'];
  /** Temporary unique generated user token */
  userToken?: Maybe<Scalars['String']['output']>;
};

export type ResultUrlPayloadType = {
  name: Scalars['String']['input'];
  value: Array<Scalars['String']['input']>;
};

/**
 * The object for representation reviews about users (this is the evaluation
 * of work). Review can be from buyer or seller.
 */
export type Review = {
  __typename?: 'Review';
  /** A type of the review source */
  category?: Maybe<ReviewCategory>;
  /** A date of created for current review */
  createdAt: Scalars['String']['output'];
  hasCounterReview: Scalars['Boolean']['output'];
  /** The id of current review */
  id: Scalars['Int']['output'];
  overallRating: RatingValues;
  /** A creator of review */
  owner: User;
  /** A product for the current review */
  product?: Maybe<ProductDetails>;
  /** A emotional state of review */
  rating: ReviewRating;
  /** A text of current review */
  text?: Maybe<Scalars['String']['output']>;
};

export enum ReviewCategory {
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

export type ReviewConnection = {
  __typename?: 'ReviewConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ReviewEdge>>;
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Review` and its cursor. */
export type ReviewEdge = {
  __typename?: 'ReviewEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Review>;
};

export type ReviewFilters = {
  category?: InputMaybe<ReviewCategory>;
  rating?: InputMaybe<ReviewRating>;
};

/** Type, that represents some question in review */
export type ReviewQuestion = {
  __typename?: 'ReviewQuestion';
  /** String identifier of question */
  id: Scalars['String']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Selected earlier answer, if exists */
  selectedValue?: Maybe<Scalars['String']['output']>;
  /** Question title */
  title: Scalars['String']['output'];
  /** Question type */
  type: QuestionType;
  valueChoices: Array<ReviewQuestionValue>;
};

/**
 * Just simple wrap up of questions,
 * for dividing them in blocks on client side
 */
export type ReviewQuestionBlock = {
  __typename?: 'ReviewQuestionBlock';
  questions: Array<ReviewQuestion>;
};

/** Type, that represents answer to question */
export type ReviewQuestionValue = {
  __typename?: 'ReviewQuestionValue';
  /** Id of answer value */
  id: Scalars['String']['output'];
  /** Human-readable answer value */
  text: Scalars['String']['output'];
};

export enum ReviewRating {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type ReviewRequest = {
  __typename?: 'ReviewRequest';
  hasCounterReview: Scalars['Boolean']['output'];
  hasSell: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  productReviewForms?: Maybe<Array<ProductReviewForm>>;
  threadId: Scalars['Int']['output'];
  userReviewForm?: Maybe<UserReviewForm>;
  /** Dialog user role */
  userRole: UserRole;
  userToId: Scalars['Int']['output'];
};

export type ReviewSort = {
  rating?: InputMaybe<ReviewRating>;
};

export type RootCatalog = {
  __typename?: 'RootCatalog';
  alsoSearchCrossLinking: Array<SeoTag>;
  breadcrumbs: Array<RootCatalog>;
  characteristics: Array<ProductCharacteristic>;
  /** Full path for category in format like "Apparel & Accessories > Clothing > Dresses" */
  googleProductCategory?: Maybe<Scalars['String']['output']>;
  /** The id of google product category */
  googleProductCategoryId?: Maybe<Scalars['Int']['output']>;
  /** The id of current catalog */
  id: Scalars['String']['output'];
  /** Mark catalog as adult only */
  isAdultOnly: Scalars['Boolean']['output'];
  isColorRequired: Scalars['Boolean']['output'];
  /** Meta description for catalog */
  metaDescription: Scalars['String']['output'];
  /** Meta title for catalog */
  metaTitle: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /**
   * Catalog namespace. Not provided for root catalog
   * @deprecated Use namespaceInfo field instead
   */
  namespace?: Maybe<CatalogNamespaces>;
  /** Catalog namespace. Not provided for root catalog */
  namespaceInfo?: Maybe<Namespace>;
  path?: Maybe<Scalars['String']['output']>;
  /** Redirect url */
  redirectTo?: Maybe<Scalars['String']['output']>;
  sales: Array<GraphSale>;
  /** Seo description for catalog (It's not META description !!!) */
  seoDescription?: Maybe<Scalars['String']['output']>;
  /** Seo title for catalog (It's not META title !!!) */
  seoTitle?: Maybe<Scalars['String']['output']>;
  siblings: Array<RootCatalog>;
  sizeGroup?: Maybe<SizeGroupType>;
  /** Slug is unique so it uses instead of primary key   */
  slug: Scalars['String']['output'];
  subCatalogs?: Maybe<Array<Maybe<RootCatalog>>>;
  tagGroupCrossLinking: Array<SeoTagGroupCrossLinking>;
  url: Scalars['String']['output'];
};


export type RootCatalogAlsoSearchCrossLinkingArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RootCatalogCharacteristicsArgs = {
  hideInternal?: InputMaybe<Scalars['Boolean']['input']>;
};


export type RootCatalogMetaDescriptionArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<IndexedFilterInput>;
};


export type RootCatalogMetaTitleArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<IndexedFilterInput>;
};


export type RootCatalogNameArgs = {
  filter?: InputMaybe<IndexedFilterInput>;
};


export type RootCatalogSeoDescriptionArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<IndexedFilterInput>;
};


export type RootCatalogSeoTitleArgs = {
  citySlug?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<IndexedFilterInput>;
};

export type Rule = {
  __typename?: 'Rule';
  /** Flag, if the decline rule can be fixed by user */
  canBeFixed: Scalars['Boolean']['output'];
  /** Verbose description of decline rule */
  explanation?: Maybe<Scalars['String']['output']>;
  /** Rule id */
  id: Scalars['Int']['output'];
  /** Name of decline rule */
  name: Scalars['String']['output'];
};

export type SaleBannerType = {
  __typename?: 'SaleBannerType';
  /** Hex banner color */
  color: Scalars['String']['output'];
  image: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SaleConnection = {
  __typename?: 'SaleConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SaleEdge>>;
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Sale` and its cursor. */
export type SaleEdge = {
  __typename?: 'SaleEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<GraphSale>;
};

/**
 * Product label for sale
 * Only usable within product context
 */
export type SaleLabel = {
  __typename?: 'SaleLabel';
  /** Context date, related to status */
  date: Scalars['Date']['output'];
  /** Product context price, related to status */
  price: Scalars['Decimal']['output'];
  sale?: Maybe<GraphSale>;
  /** Sale status enum */
  status: ProductSaleStatus;
};

/** All information about Sales */
export type SalesInfoQuery = {
  __typename?: 'SalesInfoQuery';
  activeSales?: Maybe<SaleConnection>;
  /** List of all not ended sales */
  notEndedSales: Array<GraphSale>;
  /** List of all not started sales */
  notStartedSales: Array<GraphSale>;
  /**
   * Badge with count of sales available for user participation
   * @deprecated Dont use
   */
  viewerAvailableSalesCount: Scalars['String']['output'];
};


/** All information about Sales */
export type SalesInfoQueryActiveSalesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type SavedSearch = {
  __typename?: 'SavedSearch';
  brands: Array<Brand>;
  catalog: RootCatalog;
  characteristics: Array<ProductCharacteristic>;
  cities: Array<City>;
  colors: Array<Color>;
  conditions: Array<Condition>;
  freeShipping?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  isNewProductsNotifyEnabled: Scalars['Boolean']['output'];
  isOnSale?: Maybe<Scalars['Boolean']['output']>;
  lastViewedProductId: Scalars['Int']['output'];
  newProductsCount: Scalars['Int']['output'];
  priceFrom?: Maybe<Scalars['Float']['output']>;
  priceTo?: Maybe<Scalars['Float']['output']>;
  searchText?: Maybe<Scalars['String']['output']>;
  sizes: Array<Size>;
  ukrainian?: Maybe<Scalars['Boolean']['output']>;
};

export type SellerRatingInfo = {
  __typename?: 'SellerRatingInfo';
  blocks: Array<SellerRatingInfoBlock>;
  overallRating: Scalars['String']['output'];
  reviewsCount: Scalars['Int']['output'];
  reviewsCountByPeriod: Scalars['Int']['output'];
};

export type SellerRatingInfoBlock = {
  __typename?: 'SellerRatingInfoBlock';
  items: Array<SellerRatingItem>;
};

export type SellerRatingItem = {
  __typename?: 'SellerRatingItem';
  title: Scalars['String']['output'];
  value?: Maybe<SellerRatingValue>;
};

export type SellerRatingValue = PosNegValue | RatingValue | TextValue;

export enum SellerTypeEnum {
  IsMediocreSeller = 'IS_MEDIOCRE_SELLER',
  IsNewSeller = 'IS_NEW_SELLER',
  IsTopSeller = 'IS_TOP_SELLER'
}

export enum SellingConditionEnum {
  Exchange = 'EXCHANGE',
  ForSaleAndExchange = 'FOR_SALE_AND_EXCHANGE',
  Gift = 'GIFT',
  Sale = 'SALE'
}

/** Mutation for send sms */
export type SendSms = {
  __typename?: 'SendSMS';
  /** Create product errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess: Scalars['Boolean']['output'];
};

export type SeoTag = {
  __typename?: 'SeoTag';
  anchorTitle: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type SeoTagAnchorTitleArgs = {
  to?: InputMaybe<Scalars['String']['input']>;
};

/** Used in web SEO for cross-linking in catalogs */
export type SeoTagGroupCrossLinking = {
  __typename?: 'SeoTagGroupCrossLinking';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  tags: Array<SeoTag>;
};

/**
 * Object that represents result of created service payment
 * (balance refill, promotion)
 */
export type ServicePaymentResponse = {
  __typename?: 'ServicePaymentResponse';
  /** 3DSecure link to confirm transaction from bank side. On some cards may be absent (transaction will proceed immediately) */
  confirmationUrl?: Maybe<Scalars['String']['output']>;
  /** details for service payment */
  paymentDetails?: Maybe<PaymentDetails>;
  /** Id of payment callback in database */
  paymentId: Scalars['Int']['output'];
};

/**
 *
 *     Enum that represents, which button should
 *     be rendered on "thank you" page at clients
 *
 */
export enum ServicePaymentResultButton {
  MyOrders = 'MY_ORDERS',
  Succeed = 'SUCCEED',
  TryAgain = 'TRY_AGAIN'
}

/**
 *
 *     Using same enum as on `basket` for plain orders
 *
 */
export enum ServicePaymentStatus {
  NotNeeded = 'NOT_NEEDED',
  NotPaid = 'NOT_PAID',
  Paid = 'PAID'
}

export enum ShowRealNameEnum {
  ShowRealNameForEveryone = 'SHOW_REAL_NAME_FOR_EVERYONE',
  ShowRealNameForNobody = 'SHOW_REAL_NAME_FOR_NOBODY',
  ShowRealNameForRegisteredUsers = 'SHOW_REAL_NAME_FOR_REGISTERED_USERS'
}

export enum ShowSocialWebSiteEnum {
  No = 'NO',
  Yes = 'YES'
}

/** Size type. */
export type Size = {
  __typename?: 'Size';
  /** size id */
  id: Scalars['Int']['output'];
  /** size name */
  name: Scalars['String']['output'];
  /** primary size name */
  primarySizeName: Scalars['String']['output'];
  /** secondary (optional) size name */
  secondarySizeName?: Maybe<Scalars['String']['output']>;
};

export type SizeGroupType = {
  __typename?: 'SizeGroupType';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

/** A size filter type. Id can be used for filtering. */
export type SizeType = {
  __typename?: 'SizeType';
  /** size id */
  id: Scalars['Int']['output'];
  /** size name */
  name: Scalars['String']['output'];
  /** primary size name */
  primarySizeName: Scalars['String']['output'];
  /** secondary (optional) size name */
  secondarySizeName?: Maybe<Scalars['String']['output']>;
};

export type SlideImage = {
  __typename?: 'SlideImage';
  mobile: Scalars['String']['output'];
  tablet: Scalars['String']['output'];
};

/** An enumeration. */
export enum SmartTariffsVersionEnum {
  Version1 = 'VERSION1',
  Version2 = 'VERSION2'
}

/**
 * This is the implementation of the way to authorize via socials
 *
 * Used only by Mobile devices. For desktop we use OAuth authorization
 *
 * ### error_codes(field '\__all\__'):
 *
 * * __auth_unknown_social_service__ - Client provides wrong social service
 *
 * * __auth_no_such_user_registered__ - No such user registered
 *
 * * __auth_deleted_user__ - User deleted
 *
 * * __auth_social_service_not_responding__ - social service not responding
 */
export type SocialAuthorization = {
  __typename?: 'SocialAuthorization';
  authToken?: Maybe<Scalars['String']['output']>;
  /** Upload photo errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** Authorized user   */
  user?: Maybe<User>;
};

/**
 * User registration via socials
 *
 * ### error_codes(field 'email'):
 *
 * * __reg_email_registered__ - Email already registered
 *
 * * __reg_email_provider_is_blocked__ - Provided email is blocked
 *
 * ### error_codes(field 'username'):
 *
 * * __reg_username_illegal_chars__ - Username contains disallowed substring
 *  or bad first char or bad last char
 *
 * * __reg_username_is_tooshort__ - Too short
 *
 * * __reg_username_is_toolong__ - Too long
 *
 * * __reg_username_only_one_dot__ - Too many dots
 *
 * * __reg_username_toomuch_specchars__ - Too many special chars
 *
 * * __reg_username_contains_spaces__ - Username contains spaces
 *
 * * __reg_username_is_taken__ - Username already taken by another user
 *
 * ### error_codes(field 'service'):
 *
 * * __reg_unknown_social_service__ - Client provides wrong social service
 *
 * ### error_codes(field '__all__'):
 *
 * * __reg_invalid_social_token__ - Client provides wrong access token
 *
 * * __reg_social_user_registered__ - User already registered
 *
 * * __auth_social_service_not_responding__ - social service not responding
 */
export type SocialRegistration = {
  __typename?: 'SocialRegistration';
  authToken?: Maybe<Scalars['String']['output']>;
  /** Upload photo errors */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  /** Authorized user */
  user?: Maybe<User>;
};

/** A sorting filter type. Id can be used for sorting. */
export type SortType = {
  __typename?: 'SortType';
  /** filter id */
  id: Scalars['Int']['output'];
  /** filter name */
  name: Scalars['String']['output'];
};

/**
 * This object need to represent info which related with static flags
 * features.
 */
export type StaticFlags = {
  __typename?: 'StaticFlags';
  /** *True* if balance widget enable */
  balanceEnable: Scalars['Boolean']['output'];
  /** *True* if need to show commission */
  commissionEnable: Scalars['Boolean']['output'];
  /**
   * *True* if izi logic enable
   * @deprecated always False
   */
  iziEnable: Scalars['Boolean']['output'];
  /** *True* if need to show orders info */
  ordersEnable: Scalars['Boolean']['output'];
  /** *True* if promotion widget enable */
  promotionEnable: Scalars['Boolean']['output'];
  /** *True* if referral widget enable */
  referralEnable: Scalars['Boolean']['output'];
};

/** Status type. */
export type Status = {
  __typename?: 'Status';
  /** status id */
  id: Scalars['Int']['output'];
  /** status name */
  name: Scalars['String']['output'];
};

export type SubscriptionInfo = {
  __typename?: 'SubscriptionInfo';
  /** subscription advantages */
  advantages: Array<AdvantageType>;
  autoRenewingText?: Maybe<Scalars['String']['output']>;
  availableUntilTheTime?: Maybe<Scalars['DateTime']['output']>;
  description: Scalars['String']['output'];
  detailInfo: Array<DetailType>;
  /** With html tags */
  dialogText?: Maybe<Scalars['String']['output']>;
  isAvailableTrial: Scalars['Boolean']['output'];
  mainBannerText?: Maybe<Scalars['String']['output']>;
  /**
   * Min price for activating subscription advantages
   * @deprecated This field is deprecated. Use `min_order_price` from plan type instead.
   */
  minPurchaseCondition: Scalars['Decimal']['output'];
  /** Existing subscription variants */
  plans: Array<PlanType>;
  plansNote?: Maybe<Scalars['String']['output']>;
  /** Potential saved money for subscription */
  potentialSavedMoneyForSubscription?: Maybe<Scalars['Decimal']['output']>;
  productBannerText?: Maybe<Scalars['String']['output']>;
  productText?: Maybe<Scalars['String']['output']>;
  /** Saved money for subscription */
  savedMoneyForSubscription?: Maybe<Scalars['Decimal']['output']>;
};

export type SubscriptionInfoType = {
  __typename?: 'SubscriptionInfoType';
  endAt: Scalars['Date']['output'];
  hasAutoRenew: Scalars['Boolean']['output'];
  hasSpecialTariff: Scalars['Boolean']['output'];
  plan: PlanType;
  tariffsVersion: SmartTariffsVersionEnum;
};

/**
 * Errors:
 *  max_suspend_amount - Max suspend amount
 */
export type SuspendPotentialDeal = {
  __typename?: 'SuspendPotentialDeal';
  errors?: Maybe<Array<GraphResponseError>>;
};

/**
 * Enum with tags
 *     - UKRBRAND - made in UK tag
 *     - FREE_SHIPPING - Promo action tag - free shipping
 */
export enum TagsEnum {
  AdultOnly = 'ADULT_ONLY',
  FreeShipping = 'FREE_SHIPPING',
  FromRozetka = 'FROM_ROZETKA',
  PromoteForGoogle = 'PROMOTE_FOR_GOOGLE',
  SmartAvailable = 'SMART_AVAILABLE',
  Ukrbrand = 'UKRBRAND'
}

/** The object for representation information about tariff for the payment. */
export type Tariff = {
  __typename?: 'Tariff';
  /** The number representation of tariff in bonuses. */
  bonusPrice: Scalars['Float']['output'];
  /** The currency of cost. */
  currency: Scalars['String']['output'];
  /** The key/value object with params for the payment form with default payment credit card. */
  defaultParams?: Maybe<WfpParams>;
  /** The id of promotion. */
  id: Scalars['Int']['output'];
  /** Is `True` if param is default. */
  isDefault: Scalars['Boolean']['output'];
  /** The key/value object with params for the payment form. */
  params?: Maybe<WfpParams>;
  /** The work period of promotion. */
  period: Scalars['String']['output'];
  /** The number representation of tariff cost. */
  price: Scalars['Float']['output'];
  /** The number representation of tariff cost without sale. */
  priceWithoutSale: Scalars['String']['output'];
  /** The url for payment system. */
  url?: Maybe<Scalars['String']['output']>;
};

/** The object for presentation data of message templates (MessageTemplate). */
export type TemplateMessage = {
  __typename?: 'TemplateMessage';
  /** The text of current template. */
  body: Scalars['String']['output'];
  /** The pk of current template. Use it for removing. */
  id: Scalars['Int']['output'];
  /** The title of current template. max_length=5 */
  title: Scalars['String']['output'];
};

/**
 * Implement auto slicing and other help full think. The pagination are not
 * optimal so this class need rewrite if limit of templates will be larger
 * the five.
 */
export type TemplateMessageConnection = {
  __typename?: 'TemplateMessageConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TemplateMessageEdge>>;
  limit?: Maybe<Scalars['Int']['output']>;
  pageInfo: PageInfo;
};

/** A Relay edge containing a `TemplateMessage` and its cursor. */
export type TemplateMessageEdge = {
  __typename?: 'TemplateMessageEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TemplateMessage>;
};

export type TextValue = {
  __typename?: 'TextValue';
  img: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** The main object for representation data connected with dialog. */
export type Thread = {
  __typename?: 'Thread';
  /** Commission for ppc according total_commission value */
  analyticCommission?: Maybe<Scalars['MoneyType']['output']>;
  /** If dialog not blocked - NOT_BLOCKED If dialog is blocked and user initiator - BLOCKED_BY_VIEWER If dialog is blocked and user not initiator - BLOCKED_BY_PARTICIPANT */
  blockStatus?: Maybe<BlockStatus>;
  /** Is current user can block this dialog */
  canBlock: Scalars['Boolean']['output'];
  /** Is current user can write to this dialog */
  canWrite: Scalars['Boolean']['output'];
  /** Commission percentage for this product dialog, if it will be sold */
  commissionPercent?: Maybe<Scalars['String']['output']>;
  /** If product has a big discount */
  hasBigDiscount: Scalars['Boolean']['output'];
  /** The id of the current dialog. */
  id: Scalars['Int']['output'];
  /** Is True, if the current user marked this message as favorites. */
  isImportant?: Maybe<Scalars['Boolean']['output']>;
  /** Is seller is restricted by bank id */
  isSellerRestrictedByBankId?: Maybe<Scalars['Boolean']['output']>;
  /** Is True, if current dialog exist unread messages. */
  isUnread: Scalars['Boolean']['output'];
  /** The last messages in the current dialog. */
  lastMessage: Message;
  /** The last read message in the current dialog. */
  lastReadMessage?: Maybe<Message>;
  /** The cursor of the last_read_message. */
  lastReadMessageCursor?: Maybe<Scalars['String']['output']>;
  /** The list of messages connected with the current dialog.Don't use that for fetch last message. */
  messages?: Maybe<MessageConnection>;
  /** Order linked to this dialog */
  order?: Maybe<OrderType>;
  /** Id of order, that linked to this thead */
  orderId?: Maybe<Scalars['Int']['output']>;
  /** If order was declined */
  orderIsDeclined?: Maybe<Scalars['Boolean']['output']>;
  /** The user who is participant in the current dialog. */
  participant: User;
  /** Preview images for the dialog */
  previewImages?: Maybe<Array<Scalars['String']['output']>>;
  /** The product that connected with the current dialog. */
  product?: Maybe<ProductDetails>;
  productVariant?: Maybe<ProductVariantType>;
  productsInfo: Array<ThreadProductInfo>;
  /** If True, client should request user to accept last orderfor current thread */
  requestOrderAccept: Scalars['Boolean']['output'];
  /** The subject text of the current dialog. */
  subject: Scalars['String']['output'];
  /** Id of swap order */
  swapOrderId?: Maybe<Scalars['Int']['output']>;
  /** The thread_id of the current dialog. */
  threadId: Scalars['Int']['output'];
  /** Sum of all product commission */
  totalCommission?: Maybe<Scalars['MoneyType']['output']>;
  /** The sum of all products in the dialog */
  totalPrice?: Maybe<Scalars['MoneyType']['output']>;
  /** The count of unread messages for the current dialog. */
  unreadMessagesCount: Scalars['Int']['output'];
  /** The count of unread messages for the recipient's dialog. */
  unreadRecipientMessagesCount?: Maybe<Scalars['Int']['output']>;
  /** Dialog user role */
  userRole: UserRole;
  /** Some text that must shows before all messages */
  warning?: Maybe<ThreadWarning>;
};


/** The main object for representation data connected with dialog. */
export type ThreadMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ThreadConnection = {
  __typename?: 'ThreadConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ThreadEdge>>;
  pageInfo: PageInfo;
};

/** A Relay edge containing a `Thread` and its cursor. */
export type ThreadEdge = {
  __typename?: 'ThreadEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Thread>;
};

export type ThreadFilters = {
  type?: InputMaybe<ThreadType>;
};

export type ThreadProductInfo = {
  __typename?: 'ThreadProductInfo';
  amount: Scalars['Int']['output'];
  commission: Scalars['MoneyType']['output'];
  commissionPercent: Scalars['String']['output'];
  /** product price * amount */
  price: Scalars['String']['output'];
  product: ProductDetails;
  productPrice: Scalars['String']['output'];
};

export enum ThreadType {
  Archive = 'ARCHIVE',
  Favorite = 'FAVORITE',
  Unread = 'UNREAD'
}

export type ThreadWarning = {
  __typename?: 'ThreadWarning';
  /** Hint text */
  text: Scalars['String']['output'];
};

export type TofuDigestData = {
  __typename?: 'TofuDigestData';
  /** Shafa digest for disabling sync */
  disableSyncDigest?: Maybe<Scalars['String']['output']>;
  /** Shafa digest for enabling sync */
  enableSyncDigest?: Maybe<Scalars['String']['output']>;
  /** Shafa digest based on user_id and username */
  shafaDigest: Scalars['String']['output'];
};

export type TofuSyncButtonData = {
  __typename?: 'TofuSyncButtonData';
  /** Tofu sync auto enable GET parameter */
  autoEnableParameter: Scalars['String']['output'];
  /** Determines if tofu sync is enabled */
  syncEnabled: Scalars['Boolean']['output'];
  /** Url to enable import on tofu */
  tofuImportUrl: Scalars['String']['output'];
  /** Tofu user username (if sync enabled, else null) */
  tofuUsername?: Maybe<Scalars['String']['output']>;
};

export type TofuSyncDisable = {
  __typename?: 'TofuSyncDisable';
  isSuccess: Scalars['Boolean']['output'];
};

export type TofuSyncEnable = {
  __typename?: 'TofuSyncEnable';
  isSuccess: Scalars['Boolean']['output'];
};

export type TopBrands = {
  __typename?: 'TopBrands';
  brands?: Maybe<Array<Brand>>;
  topBrands?: Maybe<Array<Brand>>;
};

export type TopLevelCategory = {
  __typename?: 'TopLevelCategory';
  /** Count of products in this category */
  countOfProducts: Scalars['Int']['output'];
  /** *id* of category */
  id: Scalars['Int']['output'];
  /** Mark catalog as adult only */
  isAdultOnly: Scalars['Boolean']['output'];
  /** *name* of category */
  name: Scalars['String']['output'];
  /** *slug* of category */
  slug: Scalars['String']['output'];
};

/**
 * Mutation for phone verification on registration step or password recovery
 *
 * ### error_codes(field 'verification_code'):
 * * __min_value__ - Verification code must contain 5 characters
 * * __max_value__ - Verification code must contain 5 characters
 * * __invalid__ - Enter a whole number
 *
 * ### error_codes(field '__all__'):
 * * __sms_does_not_sent__ - Need resend sms. User data expired or doesn't exist.
 * * __code_invalid__ - Sent and Provided codes don't match
 */
export type UnauthorizedPhoneVerification = {
  __typename?: 'UnauthorizedPhoneVerification';
  /** Create product errors */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Mutation for send sms on registration step
 *
 * ### error_codes(field 'phone_number'):
 * * __invalid__ - Bad phone format
 * * __already_used__ - Phone already used by another user
 *
 * ### error_codes(field '__all__'):
 * * __too_many_requests__ - User send too much sms
 */
export type UnauthorizedSendSms = {
  __typename?: 'UnauthorizedSendSMS';
  /** Create product errors */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess: Scalars['Boolean']['output'];
  /** Temporary unique generated user token */
  userToken?: Maybe<Scalars['String']['output']>;
};

/** The mutation remove dialog from black list by current user. */
export type UnblockDialogMutation = {
  __typename?: 'UnblockDialogMutation';
  /** Unblock dialog errors. */
  errors?: Maybe<Array<GraphResponseError>>;
  /** The representation of dialog. */
  thread?: Maybe<Thread>;
};

export type UpdateAutoRenew = {
  __typename?: 'UpdateAutoRenew';
  errors?: Maybe<Array<GraphResponseError>>;
};

/** This is the implementation of the way to change product's status by owner. */
export type UpdateProductStatus = {
  __typename?: 'UpdateProductStatus';
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

/** Mutation for phone verification and save it */
export type UpdateWorkStatus = {
  __typename?: 'UpdateWorkStatus';
  errors?: Maybe<Array<GraphResponseError>>;
  user?: Maybe<User>;
};

/** Mutation for upload photo as attachment to message */
export type UploadMessagePhoto = {
  __typename?: 'UploadMessagePhoto';
  /** Upload photo errors */
  errors?: Maybe<Array<GraphResponseError>>;
  /** Uploaded photo id */
  id?: Maybe<Scalars['String']['output']>;
  /** uploaded photo id str */
  idStr?: Maybe<Scalars['String']['output']>;
  /** uploaded photo original url */
  originalUrl?: Maybe<Scalars['String']['output']>;
  /** uploaded photo thumbnail url */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

/** Mutation for upload photo in product create action */
export type UploadPhoto = {
  __typename?: 'UploadPhoto';
  /** Upload photo errors */
  errors?: Maybe<Array<GraphResponseError>>;
  /** uploaded photo id */
  id?: Maybe<Scalars['String']['output']>;
  /** uploaded photo id str */
  idStr?: Maybe<Scalars['String']['output']>;
  /** uploaded photo original url */
  originalUrl?: Maybe<Scalars['String']['output']>;
  /** uploaded photo thumbnail url */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

export type UploadUserPhoto = {
  __typename?: 'UploadUserPhoto';
  /** Uploaded photo thumbnail url   */
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * A user is an account on the site that is given the possibility to
 * create/buy products, add product in favourite and have a chat with other
 * users.
 */
export type User = {
  __typename?: 'User';
  /** The description text about current user.   */
  about?: Maybe<Scalars['String']['output']>;
  /** Add product status for base user and PRO  */
  addProductStatus?: Maybe<AddProductStatusEnum>;
  /** The main object for representation info about admin messages.Use only for current viewer. */
  adminThreads?: Maybe<ThreadConnection>;
  /** The count of positive reviews for user as seller */
  asSellerPositiveReviews: Scalars['Int']['output'];
  /**
   * Base user - available products count for publishingPro user - free products count for publishing
   * @deprecated Any user can add any products count
   */
  availableProductsCount?: Maybe<Scalars['Int']['output']>;
  /** The balance (UAH) for the current user */
  balance: Scalars['Float']['output'];
  /** Represent ban of user (null if there is no ban) */
  ban?: Maybe<UserBanInfo>;
  /** Does the user blocked or NOT_BLOCKED  */
  blockedBy?: Maybe<UserBlockedBy>;
  /** The bonus (UAH) for the current user */
  bonus: Scalars['Float']['output'];
  /** Is True if user can use cpa   */
  canUseCpa?: Maybe<Scalars['Boolean']['output']>;
  /** Shows if user has access to this feature */
  canUseFreePush: Scalars['Boolean']['output'];
  /** The city */
  city?: Maybe<City>;
  /**
   * CPA conversion for current user
   * @deprecated CPA deleted
   */
  cpaConversion?: Maybe<ConversionEnum>;
  /**
   * The setting of frequency email sending.
   * @deprecated Unused
   */
  dailyEmailThreshold?: Maybe<DailyEmailThresholdEnum>;
  /** The date joined */
  dateJoined: Scalars['String']['output'];
  /** User current debt level, if `null` then user doesn't have debt */
  debtLevel?: Maybe<DebtLevels>;
  /** The user friendly time between joins and now */
  deltaDateJoined: Scalars['String']['output'];
  /** An email of user */
  email?: Maybe<Scalars['String']['output']>;
  /** The list of products which were added by user like favourite */
  favourites?: Maybe<FeedConnection>;
  /** Possible catalogs for filtering by user favourite products */
  favouritesCatalogs?: Maybe<Array<Maybe<FilterCatalog>>>;
  /** The first name of current user.   */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The count of followers to current user */
  followersCount: Scalars['Int']['output'];
  /** Is True if user has a fraud warning */
  fraudWarning: Scalars['Boolean']['output'];
  /** Free push ups left (0 if not super seller) */
  freePushupsLeft: Scalars['Int']['output'];
  /** Monthly free puhsup limit */
  freePushupsLimit: Scalars['Int']['output'];
  /** Free shipping information */
  freeShippingInfo?: Maybe<FreeShippingInfoType>;
  /** The gender type of current user.   */
  gender?: Maybe<GenderEnum>;
  hasMobileApp: Scalars['Boolean']['output'];
  hasPotentialDeals: Scalars['Boolean']['output'];
  /** True if user visit site not so long ago. */
  hasRecentActivity: Scalars['Boolean']['output'];
  hasUnreadNotifications?: Maybe<Scalars['Boolean']['output']>;
  /** An id of User */
  id: Scalars['Int']['output'];
  /** Is the user has an active multiple action task.   */
  isActiveMultipleAction?: Maybe<Scalars['Boolean']['output']>;
  /** resolves if user have admin access type */
  isAdmin: Scalars['Boolean']['output'];
  /** Is user verification by bank id is mandatory for user */
  isBankIdVerificationMandatory: Scalars['Boolean']['output'];
  /** Is user verified by bank id */
  isBankIdVerified: Scalars['Boolean']['output'];
  isMediocreSeller: Scalars['Boolean']['output'];
  isNewBuyer: Scalars['Boolean']['output'];
  isNewSeller: Scalars['Boolean']['output'];
  /** Is user phone verified   */
  isPhoneVerified?: Maybe<Scalars['Boolean']['output']>;
  /** User meets the conditions of private seller */
  isPrivateSeller: Scalars['Boolean']['output'];
  /**
   * Is PRO activated for user
   * @deprecated PRO deprecated
   */
  isPro?: Maybe<Scalars['Boolean']['output']>;
  isSeller: Scalars['Boolean']['output'];
  /** if current user_id is subscribed to seller*True*. Client must have a header *HTTP_X_AUTH_TOKEN* */
  isSubscribed: Scalars['Boolean']['output'];
  isTopSeller: Scalars['Boolean']['output'];
  /** Is some features disabled for user because of BankId verification absence */
  isUserRestrictedByBankId: Scalars['Boolean']['output'];
  isWorking: Scalars['Boolean']['output'];
  /** The last name of current user.   */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Last products photos   */
  lastProductsPhotos?: Maybe<Array<Maybe<Photo>>>;
  /** Last review request after transaction */
  lastReviewRequest?: Maybe<ReviewRequest>;
  /** The last time visit */
  lastVisit?: Maybe<Scalars['Int']['output']>;
  /** The middle time of response to first message. This value is calculated only for dialogs that made for seller. */
  middleResponseTime?: Maybe<Scalars['String']['output']>;
  /** Minimum amount for refill balance */
  minRefillAmount?: Maybe<Scalars['Int']['output']>;
  /** The count of negative reviews */
  negativeReviews: Scalars['Int']['output'];
  /**
   * Settings connected with user`s notification.
   * @deprecated user user_notification_settings
   */
  notificationSettings?: Maybe<UserNotificationSettings>;
  notifications?: Maybe<NotificationConnection>;
  /** Percent of done orders */
  orderRate?: Maybe<Scalars['String']['output']>;
  /** The patronymic of current user.   */
  patronymic?: Maybe<Scalars['String']['output']>;
  /** The list of user`s payment transactions */
  paymentTransactions: PaymentTransactionConnection;
  /** Phone number of current user */
  phone?: Maybe<Scalars['String']['output']>;
  /** The count of positive reviews */
  positiveReviews: Scalars['Int']['output'];
  /** The list of user`s products */
  products: FeedConnection;
  /** The list of user`s products by subscriptions   */
  productsBySubscriptions?: Maybe<FeedConnection>;
  /** Possible catalogs for filtering by user products by subscriptions */
  productsBySubscriptionsCatalogs?: Maybe<Array<Maybe<FilterCatalog>>>;
  /** Possible catalogs for filtering by user active products */
  productsCatalogs: Array<FilterCatalog>;
  /** The count of products for current user */
  productsCount?: Maybe<Scalars['Int']['output']>;
  /** The list of possible state filters on the profile feed. */
  productsStateFilters?: Maybe<Array<ProductStateFilter>>;
  /** Viewer info for referral program   */
  referralProgramInfo?: Maybe<ReferralProgramInfo>;
  /** The list of user`s reviews */
  reviews?: Maybe<ReviewConnection>;
  /** User-related sales information */
  salesInfo: SalesInfoQuery;
  savedSearches: Array<SavedSearch>;
  /**
   * User rating as a seller
   * @deprecated User seller_rating_info
   */
  sellerRating?: Maybe<Scalars['Float']['output']>;
  sellerRatingInfo?: Maybe<SellerRatingInfo>;
  /** Shop name */
  shopName?: Maybe<Scalars['String']['output']>;
  /** The setting of who can see your real name.   */
  showRealName?: Maybe<ShowRealNameEnum>;
  /** The setting of who can see your social website.   */
  showSocialWebSite?: Maybe<ShowSocialWebSiteEnum>;
  /** Amount of sold products */
  soldProducts: Scalars['Int']['output'];
  /** Users that are subscribed on this user   */
  subscribers?: Maybe<UserConnection>;
  subscriptionInfo?: Maybe<SubscriptionInfoType>;
  /** Users on who this user subscript   */
  subscriptions?: Maybe<UserConnection>;
  /** The main object for representation info about template of messages. */
  templateMessages?: Maybe<TemplateMessageConnection>;
  /** The main object for representation info about one thread. */
  thread?: Maybe<Thread>;
  /** The main object for representation info about messages.Use only for current viewer. */
  threads?: Maybe<ThreadConnection>;
  /** An url of user's thumbnail */
  thumbnail: Scalars['String']['output'];
  /** The count of unread admin messages for current user. */
  unreadAdminMessagesCount: Scalars['Int']['output'];
  /** The count of unread messages for current user. */
  unreadMessagesCount: Scalars['Int']['output'];
  /** User self url   */
  url?: Maybe<Scalars['String']['output']>;
  userNotificationSettings: Array<NotificationSettings>;
  /** An username of user */
  username: Scalars['String']['output'];
  /** resolves if viewer can complain on user   */
  viewerCanComplain: Scalars['Boolean']['output'];
  /** The list of viewer products sorted by typeDefault sort status - 'ACTIVE' */
  viewerProducts: FeedConnection;
  /**
   * The count of products for current viewer
   * @deprecated The same functionality provided in productsCount field
   */
  viewerProductsCount?: Maybe<Scalars['Int']['output']>;
};


/**
 * A user is an account on the site that is given the possibility to
 * create/buy products, add product in favourite and have a chat with other
 * users.
 */
export type UserAdminThreadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A user is an account on the site that is given the possibility to
 * create/buy products, add product in favourite and have a chat with other
 * users.
 */
export type UserFavouritesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brands?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  characteristics?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  priceFrom?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priceTo?: InputMaybe<Scalars['Int']['input']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ukrainian?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A user is an account on the site that is given the possibility to
 * create/buy products, add product in favourite and have a chat with other
 * users.
 */
export type UserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A user is an account on the site that is given the possibility to
 * create/buy products, add product in favourite and have a chat with other
 * users.
 */
export type UserPaymentTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A user is an account on the site that is given the possibility to
 * create/buy products, add product in favourite and have a chat with other
 * users.
 */
export type UserProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brands?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  characteristics?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  priceFrom?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priceTo?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ukrainian?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A user is an account on the site that is given the possibility to
 * create/buy products, add product in favourite and have a chat with other
 * users.
 */
export type UserProductsBySubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brands?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  characteristics?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  priceFrom?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priceTo?: InputMaybe<Scalars['Int']['input']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ukrainian?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A user is an account on the site that is given the possibility to
 * create/buy products, add product in favourite and have a chat with other
 * users.
 */
export type UserReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ReviewFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ReviewSort>;
};


/**
 * A user is an account on the site that is given the possibility to
 * create/buy products, add product in favourite and have a chat with other
 * users.
 */
export type UserSubscribersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A user is an account on the site that is given the possibility to
 * create/buy products, add product in favourite and have a chat with other
 * users.
 */
export type UserSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A user is an account on the site that is given the possibility to
 * create/buy products, add product in favourite and have a chat with other
 * users.
 */
export type UserThreadArgs = {
  dialogId?: InputMaybe<Scalars['Int']['input']>;
  threadId?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A user is an account on the site that is given the possibility to
 * create/buy products, add product in favourite and have a chat with other
 * users.
 */
export type UserThreadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<ThreadFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  withoutAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A user is an account on the site that is given the possibility to
 * create/buy products, add product in favourite and have a chat with other
 * users.
 */
export type UserViewerProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brands?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  characteristics?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  priceFrom?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priceTo?: InputMaybe<Scalars['Int']['input']>;
  productsType?: InputMaybe<ProfileProductTypeEnum>;
  saleId?: InputMaybe<Scalars['Int']['input']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ukrainian?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Info about bans for some user */
export type UserBanInfo = {
  __typename?: 'UserBanInfo';
  /** True if ban is active */
  isActive: Scalars['Boolean']['output'];
  /** Ban reason */
  reason: Scalars['String']['output'];
  /** Enum representing why user was blocked */
  reasonType: UserBanReasonType;
  /** Datetime of ban begin */
  validFrom: Scalars['String']['output'];
  /** Datetime of ban end (null if ban is permanent) */
  validUntil?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum UserBanReasonType {
  TypeFraud = 'TYPE_FRAUD',
  TypeOther = 'TYPE_OTHER'
}

/** An enumeration. */
export enum UserBlockedBy {
  BlockedByAdmin = 'BLOCKED_BY_ADMIN',
  BlockedBySystem = 'BLOCKED_BY_SYSTEM',
  NotBlocked = 'NOT_BLOCKED'
}

export type UserBrandType = {
  __typename?: 'UserBrandType';
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
};

/**
 * Mutation for user complaint creation
 * TODO: delete after protobuf drop
 */
export type UserComplaint = {
  __typename?: 'UserComplaint';
  /** Create product errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserEdge>>;
  pageInfo: PageInfo;
};

/**
 * Soft delete the user or send a notification to the telegram chat if the user cannot
 * be deleted
 */
export type UserDelete = {
  __typename?: 'UserDelete';
  errors?: Maybe<Array<GraphResponseError>>;
};

/** A Relay edge containing a `User` and its cursor. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<User>;
};

export type UserInfo = {
  /** Client id */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** User fingerprint. Valid JSON string */
  fingerprint?: InputMaybe<Scalars['String']['input']>;
};

export type UserNotificationSettings = {
  __typename?: 'UserNotificationSettings';
  /** On / Off sending notification connected with review */
  onFeedback: Scalars['Boolean']['output'];
  /** On / Off sending notification connected with subscription */
  onFollower: Scalars['Boolean']['output'];
  onFollowerNewProduct: Scalars['Boolean']['output'];
  /** On / Off sending notification with helpful information */
  onMarketing: Scalars['Boolean']['output'];
  /** On / Off sending notification connected with messages */
  onMessage: Scalars['Boolean']['output'];
  /** On / Off sending notification connected with favorite user`s products */
  onStarred: Scalars['Boolean']['output'];
};

/**
 * Mutation for reset password if user use email for restoring password
 * Client must send `activation_key` that user received in email,
 * `newPassword` and `confirmPassword`
 *
 *
 * ### error_codes(field '__password__'):
 * * __password_mismatch__ - Passwords do not match
 * * __password_is_short__ - Password is short
 * * __password_like_username_or_email__ - Password should not be like username or
 *     email
 *
 * ### error_codes(field '\__all\__'):
 * * __reset_link_expire__ - Reset password link is expire
 */
export type UserResetPasswordViaEmail = {
  __typename?: 'UserResetPasswordViaEmail';
  authToken?: Maybe<Scalars['String']['output']>;
  /** Reset password errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess: Scalars['Boolean']['output'];
  /** Authorized user   */
  user?: Maybe<User>;
};

/**
 * Mutation for reset password if user use phone for restoring password
 * Client must send `user_token` that client received
 * from server when verified phone,
 * `newPassword` and `confirmPassword`
 *
 * ### error_codes(field '__password__'):
 * * __password_mismatch__ - Passwords do not match
 * * __password_is_short__ - Password is short
 * * __password_like_username_or_email__ - Password should not be like username or
 *     email
 *
 *
 * ### error_codes(field '\__all\__'):
 * * __sms_does_not_sent__ - Need resend sms. User data expired or doesn't exist.
 */
export type UserResetPasswordViaPhone = {
  __typename?: 'UserResetPasswordViaPhone';
  authToken?: Maybe<Scalars['String']['output']>;
  /** Reset password errors   */
  errors?: Maybe<Array<GraphResponseError>>;
  isSuccess: Scalars['Boolean']['output'];
  /** Authorized user   */
  user?: Maybe<User>;
};

export type UserReviewForm = {
  __typename?: 'UserReviewForm';
  expireDate: Scalars['Date']['output'];
  form: Array<ReviewQuestionBlock>;
  userId: Scalars['Int']['output'];
};

/** An enumeration. */
export enum UserRole {
  Buyer = 'BUYER',
  Seller = 'SELLER'
}

/**
 * The object need to represent data connected with user seo tag. User seo
 * tags are tags which user add in the product add page.
 *
 * This is mutation because we have problem with params for queries in Apollo.
 */
export type UserSeoTags = {
  __typename?: 'UserSeoTags';
  /** *id* of the current tag. */
  id: Scalars['Int']['output'];
  /** *name* of the current tag. */
  title: Scalars['String']['output'];
};

export type VirtualCatalog = {
  __typename?: 'VirtualCatalog';
  breadcrumbs: Array<VirtualCatalog>;
  id: Scalars['Int']['output'];
  linkedCatalogs: Array<LinkedCatalogUnion>;
  /**
   *
   *     Return list of products for some catalog, by default return
   *     products form women catalog.
   *
   *     By default return only first 10 items. For get other products using
   *     pagination.
   *
   *     {
   *       products(first: 10) {
   *         edges {
   *           node {
   *             id
   *           }
   *           cursor # not necessary
   *         }
   *         pageInfo {
   *           hasNextPage
   *           hasPreviousPage
   *           startCursor
   *           endCursor
   *           total
   *         }
   *       }
   *     }
   *
   *     If you want get next page, test if hasNextPage is True and next
   *     using some code like bellow:
   *
   *
   *     {
   *       products(first: 10, after: `your previous endCursor value`) {
   *         edges {
   *           node {
   *             id
   *           }
   *         }
   *         pageInfo {
   *           hasNextPage
   *           hasPreviousPage
   *           startCursor
   *           endCursor
   *           total
   *         }
   *       }
   *     }
   *
   */
  products: FeedConnection;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoMetaDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  siblings: Array<VirtualCatalog>;
  slug: Scalars['String']['output'];
  title: Scalars['String']['output'];
};


export type VirtualCatalogProductsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brands?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  catalogSlug?: InputMaybe<Scalars['String']['input']>;
  characteristics?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  cities?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  condition?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  freeShipping?: InputMaybe<Scalars['Boolean']['input']>;
  isOnSale?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageNum?: InputMaybe<Scalars['Int']['input']>;
  paginationType?: InputMaybe<ProductPaginationType>;
  priceFrom?: InputMaybe<Scalars['Int']['input']>;
  priceId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  priceTo?: InputMaybe<Scalars['Int']['input']>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sizes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ukrainian?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Visibility type. */
export type Visibility = {
  __typename?: 'Visibility';
  /** visibility id */
  id: Scalars['Int']['output'];
  /** visibility name */
  name: Scalars['String']['output'];
};

/**
 * The object for representation wfp form params. A client should not do
 * something with this data just sent, so fields from this type didn't need
 * description.
 */
export type WfpParams = {
  __typename?: 'WFPParams';
  amount?: Maybe<Scalars['String']['output']>;
  authorizationType?: Maybe<Scalars['String']['output']>;
  clientEmail?: Maybe<Scalars['String']['output']>;
  clientPhone?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  merchantAccount?: Maybe<Scalars['String']['output']>;
  merchantDomainName?: Maybe<Scalars['String']['output']>;
  merchantSignature?: Maybe<Scalars['String']['output']>;
  merchantTransactionSecureType?: Maybe<Scalars['String']['output']>;
  orderDate?: Maybe<Scalars['String']['output']>;
  orderReference?: Maybe<Scalars['String']['output']>;
  paymentSystems?: Maybe<Scalars['String']['output']>;
  productCount?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  productPrice?: Maybe<Scalars['String']['output']>;
  recToken?: Maybe<Scalars['String']['output']>;
  returnUrl?: Maybe<Scalars['String']['output']>;
  serviceUrl?: Maybe<Scalars['String']['output']>;
};

export type SubCatalogsFragment = { __typename?: 'FilterCatalog', slug: string, productsCount: number, text: string } & { ' $fragmentName'?: 'SubCatalogsFragment' };

export type ProductLikesFragment = { __typename?: 'Product', likes: number, isLiked: boolean } & { ' $fragmentName'?: 'ProductLikesFragment' };

export type ProductDetailsLikesFragment = { __typename?: 'ProductDetails', likes: number, isLiked: boolean } & { ' $fragmentName'?: 'ProductDetailsLikesFragment' };

export type ProductDetailsProductsLikesFragment = { __typename?: 'ProductDetailsProducts', likes: number, isLiked: boolean } & { ' $fragmentName'?: 'ProductDetailsProductsLikesFragment' };

export type ProductActivityFragment = { __typename?: 'ProductDetails', userStatusTitle: ProductUserStatus, isProcessingMultipleAction?: ProductMultipleActionStatus | null } & { ' $fragmentName'?: 'ProductActivityFragment' };

export type ErrorsDataFragment = { __typename?: 'GraphResponseError', field: string, messages: Array<{ __typename?: 'GraphErrorMessage', code: string, message: string }> } & { ' $fragmentName'?: 'ErrorsDataFragment' };

export type ProductCardFeedDataFragment = { __typename?: 'Product', id: number, url: string, thumbnail?: string | null, name: string, price?: number | null, oldPrice?: number | null, statusTitle?: ProductVisibleStatus | null, discountPercent?: number | null, catalogSlug?: string | null, isNew: boolean, freeDeliveryServices?: Array<DeliveryService> | null, isUkrainian: boolean, ownerHasRecentActivity: boolean, tags: Array<TagsEnum>, rating?: number | null, ratingAmount?: number | null, isViewed: boolean, createdAt?: string | null, sellingCondition: SellingConditionEnum, likes: number, isLiked: boolean, brand?: { __typename?: 'Brand', id: number, name: string } | null, sizes?: Array<{ __typename?: 'Size', id: number, name: string }> | null, saleLabel: { __typename?: 'SaleLabel', status: ProductSaleStatus, date: any, price: any }, seller: { __typename?: 'User', id: number, isTopSeller: boolean } } & { ' $fragmentName'?: 'ProductCardFeedDataFragment' };

export type ProductDetailsProductsDataFragment = { __typename?: 'ProductDetailsProducts', id: number, url: string, thumbnail?: string | null, name: string, price?: number | null, oldPrice?: number | null, statusTitle?: ProductVisibleStatus | null, isTop: boolean, discountPercent?: number | null, catalogSlug?: string | null, isNew: boolean, freeDeliveryServices?: Array<DeliveryService> | null, isUkrainian: boolean, ownerHasRecentActivity: boolean, tags: Array<TagsEnum>, rating?: number | null, ratingAmount?: number | null, likes: number, isLiked: boolean, brand?: { __typename?: 'Brand', id: number, name: string } | null, sizes?: Array<{ __typename?: 'Size', id: number, name: string }> | null, saleLabel: { __typename?: 'SaleLabel', status: ProductSaleStatus, date: any, price: any }, seller: { __typename?: 'User', id: number } } & { ' $fragmentName'?: 'ProductDetailsProductsDataFragment' };

export type MarksSoldUpdateDataFragment = { __typename?: 'ProductDetails', statusTitle?: ProductVisibleStatus | null, productCount: number } & { ' $fragmentName'?: 'MarksSoldUpdateDataFragment' };

export type NavProfileInfoFragment = { __typename?: 'User', username: string, unreadMessagesCount: number, hasUnreadNotifications?: boolean | null, avatar: string } & { ' $fragmentName'?: 'NavProfileInfoFragment' };

export type ChatMessageInfoFragment = { __typename?: 'Message', body: string, orderId?: number | null, fraudWarning?: string | null, sentAt: string, photos: Array<string>, subText?: string | null, isSystemMessage: boolean, additionalComponent: MessageAdditionalComponent, viewPhoneText?: string | null, isScheduleToSend?: boolean | null, linkButton?: { __typename?: 'MessageLinkButton', text: string, link: string } | null, sender: { __typename?: 'User', id: number, username: string, shopName?: string | null, thumbnail: string, isAdmin: boolean } } & { ' $fragmentName'?: 'ChatMessageInfoFragment' };

export type ReviewFeedDataFragment = { __typename?: 'Review', id: number, text?: string | null, overallRating: RatingValues, createdAt: string, owner: { __typename?: 'User', id: number, username: string, thumbnail: string, shopName?: string | null }, product?: { __typename?: 'ProductDetails', id: number, name: string, url: string } | null } & { ' $fragmentName'?: 'ReviewFeedDataFragment' };

export type BrandFilterDataFragment = { __typename?: 'Brand', id: number, name: string, isUkrainian?: boolean | null } & { ' $fragmentName'?: 'BrandFilterDataFragment' };

export const SubCatalogsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"subCatalogs"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FilterCatalog"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"text"},"name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"productsCount"}}]}}]} as unknown as DocumentNode;
export const ProductDetailsLikesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productDetailsLikes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"likes"}},{"kind":"Field","name":{"kind":"Name","value":"isLiked"}}]}}]} as unknown as DocumentNode;
export const ProductActivityFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productActivity"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userStatusTitle"}},{"kind":"Field","name":{"kind":"Name","value":"isProcessingMultipleAction"}}]}}]} as unknown as DocumentNode;
export const ErrorsDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"errorsData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphResponseError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"messages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]} as unknown as DocumentNode;
export const ProductLikesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productLikes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"likes"}},{"kind":"Field","name":{"kind":"Name","value":"isLiked"}}]}}]} as unknown as DocumentNode;
export const ProductCardFeedDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productCardFeedData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"oldPrice"}},{"kind":"Field","name":{"kind":"Name","value":"statusTitle"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"productLikes"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mode"},"value":{"kind":"StringValue","value":"migrate","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogSlug"}},{"kind":"Field","name":{"kind":"Name","value":"isNew"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"saleLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"freeDeliveryServices"}},{"kind":"Field","name":{"kind":"Name","value":"isUkrainian"}},{"kind":"Field","name":{"kind":"Name","value":"ownerHasRecentActivity"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"ratingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isTopSeller"}}]}},{"kind":"Field","name":{"kind":"Name","value":"isViewed"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"sellingCondition"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productLikes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Product"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"likes"}},{"kind":"Field","name":{"kind":"Name","value":"isLiked"}}]}}]} as unknown as DocumentNode;
export const ProductDetailsProductsLikesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productDetailsProductsLikes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDetailsProducts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"likes"}},{"kind":"Field","name":{"kind":"Name","value":"isLiked"}}]}}]} as unknown as DocumentNode;
export const ProductDetailsProductsDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductDetailsProductsData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDetailsProducts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"oldPrice"}},{"kind":"Field","name":{"kind":"Name","value":"statusTitle"}},{"kind":"Field","name":{"kind":"Name","value":"isTop"}},{"kind":"Field","name":{"kind":"Name","value":"discountPercent"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"productDetailsProductsLikes"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"unmask"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"mode"},"value":{"kind":"StringValue","value":"migrate","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"brand"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"catalogSlug"}},{"kind":"Field","name":{"kind":"Name","value":"isNew"}},{"kind":"Field","name":{"kind":"Name","value":"sizes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"saleLabel"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"freeDeliveryServices"}},{"kind":"Field","name":{"kind":"Name","value":"isUkrainian"}},{"kind":"Field","name":{"kind":"Name","value":"ownerHasRecentActivity"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"ratingAmount"}},{"kind":"Field","name":{"kind":"Name","value":"seller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"productDetailsProductsLikes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDetailsProducts"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"likes"}},{"kind":"Field","name":{"kind":"Name","value":"isLiked"}}]}}]} as unknown as DocumentNode;
export const MarksSoldUpdateDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"marksSoldUpdateData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductDetails"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statusTitle"}},{"kind":"Field","name":{"kind":"Name","value":"productCount"}}]}}]} as unknown as DocumentNode;
export const NavProfileInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"navProfileInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","alias":{"kind":"Name","value":"avatar"},"name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"unreadMessagesCount"}},{"kind":"Field","name":{"kind":"Name","value":"hasUnreadNotifications"}}]}}]} as unknown as DocumentNode;
export const ChatMessageInfoFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"chatMessageInfo"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Message"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"body"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}},{"kind":"Field","name":{"kind":"Name","value":"fraudWarning"}},{"kind":"Field","name":{"kind":"Name","value":"sentAt"}},{"kind":"Field","name":{"kind":"Name","value":"photos"}},{"kind":"Field","name":{"kind":"Name","value":"fraudWarning"}},{"kind":"Field","name":{"kind":"Name","value":"subText"}},{"kind":"Field","name":{"kind":"Name","value":"isSystemMessage"}},{"kind":"Field","name":{"kind":"Name","value":"additionalComponent"}},{"kind":"Field","name":{"kind":"Name","value":"linkButton"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"link"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sender"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"shopName"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}}]}},{"kind":"Field","name":{"kind":"Name","value":"viewPhoneText"}},{"kind":"Field","name":{"kind":"Name","value":"isScheduleToSend"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}]}]}}]} as unknown as DocumentNode;
export const ReviewFeedDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReviewFeedData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Review"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnail"}},{"kind":"Field","name":{"kind":"Name","value":"shopName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"overallRating"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]} as unknown as DocumentNode;
export const BrandFilterDataFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"brandFilterData"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Brand"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isUkrainian"}}]}}]} as unknown as DocumentNode;